// Core packages
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";

// Third party packages
import { MatDialog } from "@angular/material";
import { Sort } from '@angular/material/sort';
import { FormlyFieldConfig, FormlyFormOptions } from "@ngx-formly/core";
import { TranslateService } from "@ngx-translate/core";
import { CookieService } from "ngx-cookie-service";
import { ToastrService } from "ngx-toastr";
import { Subscription } from "rxjs";
import { take } from "rxjs/operators";

// Custom packages
import { IUser } from "src/app/shared/models/user/user.interface";
// import { User } from "src/app/shared/models/user/user.model";
import { AuthService } from "src/app/modules/auth/auth.service";
import { PropertiesService } from "src/app/modules/properties/properties.service";
import { Property } from "src/app/shared/models/property/property.model";
import { DateTimeFormatPipe } from "src/app/shared/pipes/date-format.pipe";
import { ConfigService } from "src/app/shared/services/config.service";
import { HelperService } from "src/app/shared/services/helper.service";
import { ThemeService } from "src/app/shared/services/theme.service";
// import { ConfirmDialogComponent } from "src/app/shared/components/dialogs/confirm-dialog/confirm-dialog.component";
import { KeyValue } from '@angular/common';
import { CompaniesService } from "src/app/modules/companies/companies.service";
import { AllDocsInterface, DisplayedDocsInterface, DocumentInterface } from "src/app/modules/properties/documents.interface";
import { SettingsService } from "src/app/modules/settings/settings.service";
import { Company } from 'src/app/shared/models/company/company.model';
import { PropertyInterface } from "src/app/shared/models/property/property.interface";
import { ApiService } from "src/app/shared/services/api.service";
import { DocumentDownloadDialogComponent } from '../../components/document-download-dialog/document-download-dialog.component';
import MappingIndex from "../../components/mapping-index.interface";
import { CondoStructuresService } from "../../condo-structures.service";
import { DocumentArchivesService } from "../../document-archives.service";
import DocumentTypeStructure from "../../documentTypes";


@Component({
  selector: 'app-view-property',
  templateUrl: './view-property.page.html',
  styleUrls: ['./view-property.page.scss']
})
export class ViewPropertyComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  loggedUser: IUser;
  loggedUserPermissions: string[];
  loggedUserRole: any;
  currentRole: any;
  lang = this.translateService.currentLang || this.translateService.defaultLang;
  // Could not be "Property" type because in "get" method in the back-end
  // We are populating some fields, so the model is not the same!
  public property: Property = new Property();
  propertyData: PropertyInterface;
  detailCardIsLoading = true;
  deleteCardIsLoading = true;
  sharedUserCardIsLoading = true;

  dateTimeFormat: DateTimeFormatPipe;

  companyAdmin = "";
  companyOwner = "";
  address = "";

  propertyId = "";
  company: Company = new Company();
  documentArchiveIsLoading = true;
  pageIsLoading = true;
  structureIsLoading = true;
  condoStructure: any;
  condoStructureOpen = true;
  documentArchiveId: string;
  insertedDocs: any[] = [];
  documentArchive: any;
  allDocs: AllDocsInterface[] = [];
  documentsStructure: DocumentInterface[] = [];
  displayedDocs: DisplayedDocsInterface[] = [];
  mappingIndex: MappingIndex[] = [];
  // @OLD mappingIndex: MappingIndex[] = MappingIndexData;
  activeItem: MappingIndex;
  @ViewChild("panelContainer", { static: false }) panelContainer: ElementRef<any>;

  // BEGIN - Formly config
  form: FormGroup = new FormGroup({});
  model: any = {};
  fields: FormlyFieldConfig[] = [];
  options: FormlyFormOptions = {
    formState: {
      disabled: false
    }
  };
  // END - Formly config
  formIsLoading = false;
  sectionPlant = false;
  formActiveSubitemId = "";
  formActiveSection = "";
  activeSubitem: any;
  loggedUserObj: any;

  totMandatoryDocs = 0;
  totInsertDocs = 0;
  totNotInsertDocs = 0;
  totOptionalDocs = 0;
  totDocs = 0;

  subscriptionType = "FREE";

  public documentTypeStructure: DocumentTypeStructure =
    new DocumentTypeStructure();

  // Dati aggiuntivi elenco/nuovo elemento
  suppliersName: any[] = [];
  yearsOfStorage: any[] = [];
  conductorName: any[] = [];
  nameInterventionArchiving: any[] = [];

  documentTemplateId = "";
  documentTemplate: any[] = [];

  condoStructureTemplateId = "";
  condoStructureTemplate: any[] = [];
  
  /**
   * Class constructor
   */
  constructor(
    private configService: ConfigService,
    private activatedRoute: ActivatedRoute,
    private propertiesService: PropertiesService,
    private router: Router,
    private toastrService: ToastrService,
    public helperService: HelperService,
    private translateService: TranslateService,
    private themeService: ThemeService,
    private authService: AuthService,
    public dialog: MatDialog,
    private cookieService: CookieService,
    private companiesService: CompaniesService,
    private apiService: ApiService, // DO NOT MOVE since it's used for 'autocomplete' field type
    // private rolesService: RolesService,
    // private subscriptionsService: SubscriptionsService,
    // private userService: UsersService,
    private condoStructuresService: CondoStructuresService,
    private documentArchivesService: DocumentArchivesService,
    private settingsService: SettingsService,
  ) {
    // @OLD
    // // Translate some string inside mappingIndex before formly get intialized
    // this.mappingIndex = this.translateKeys(
    //   ["placeholder", "label"],
    //   this.mappingIndex
    // );
  }


  /**
   * Init components
   *
   * @since 1.0.0
   */
  ngOnInit(): void {
    // Set page title
    this.themeService.setPageTitle(
      this.translateService.instant("properties.detail.pageTitle")
    );

    this.subscriptions.push(
      this.settingsService.getStructure().subscribe(
        (res) => {
          if (res.status) {
            if (
              res.condoStructureTemplate &&
              Array.isArray(res.condoStructureTemplate) &&
              res.condoStructureTemplate.length > 0 &&
              res.condoStructureTemplate[0].area &&
              Array.isArray(res.condoStructureTemplate[0].area)
            ) {
              this.condoStructureTemplateId = res.condoStructureTemplate[0]._id;
              this.condoStructureTemplate = res.condoStructureTemplate[0].area;

              this.mappingIndex = this.condoStructureTemplate;
              
              this.mappingIndex = this.translateKeys2(
                ["placeholder", "label"],
                this.mappingIndex
              );
              
            }
          }
        })
    );

    // Get logged user data
    this.subscriptions.push(this.authService.loggedUser$.subscribe(res => (this.loggedUser = res)));
    this.subscriptions.push(
      this.authService.loggedUserPermissions$.subscribe(
        res => (this.loggedUserPermissions = res)
      )
    );
    // Get logged user's role data
    this.currentRole = this.loggedUser.userRoles.find((obj: any) => {
      return (
        obj._id.toString() ===
        this.authService.loggedUserRequestedRole$.getValue().toString()
      );
    });

    if (!this.currentRole.propertiesPermission) {
      this.currentRole.propertiesPermission = {
        amiantoDoc: false,
        amminImmobile: false,
        antincendio: false,
        ascensori: false,
        contratti: false,
        edile: false,
        expiresUnlimited: false,
        gestionaleAmministrativo: false,
        impiantoElettrico: false,
        impiantiElettronici: false,
        impiantiRicreativiSportivi: false,
        impiantiSpeciali: false,
        lineaVita: false,
        mappatura: false,
        riscaldamentoCondizionamento: false,
        trattamentoAcqua: false,
        unitaImmobiliari: false,
        unlimited: false,
        gestionaleContabile: false,
        urbanisticaEdEdilizia: false,
        catasto: false,
        preventivi: false,
      }
    }

    // Get current lang
    this.lang = this.cookieService.get("lang") || this.configService.defaultLang;

  }

  /**
     * After view init logic
     *
     * @since 1.0.0
     */
  ngAfterViewInit(): void {
    if (this.currentRole.type == "shared") {
      // Get Property
      if (this.currentRole.propertiesPermission) {

        // Get requested property data
        this.propertyId = this.currentRole.propertiesPermission.property[0];

        // Get requested property data, company data and document archive
        this.subscriptions.push(
          this.propertiesService.get(this.propertyId).subscribe(
            res => {
              if (res.status) {
                this.property.setData(res.data);
                this.propertyData = res.data;

                if (
                  this.propertyData &&
                  this.propertyData.subscription &&
                  this.propertyData.subscription.key
                ) {
                  this.subscriptionType = this.propertyData.subscription.key;
                }

                if (this.propertyData.admin
                  && this.propertyData.admin.company
                  && this.propertyData.admin.company._id) {
                  this.subscriptions.push(
                    this.companiesService.get(this.propertyData.admin.company._id).subscribe(
                      res => {
                        if (res.status) {
                          this.company.setData(res.data);
                          this.companyAdmin = this.company.get("name");
                        }
                      })
                  )
                }
                this.companyOwner = "";
                if (this.propertyData.owner) {
                  this.subscriptions.push(
                    this.companiesService.get(this.propertyData.owner).subscribe(
                      res => {
                        if (res.status) {
                          this.company.setData(res.data);
                          this.companyOwner = this.company.get("name");
                        }
                      })
                  )
                }

                if (this.propertyData.address) {
                  this.address = `${this.propertyData.address.route},
                  ${this.propertyData.address.streetNumber} -
                  ${this.propertyData.address.postalCode}
                  ${this.propertyData.address.city}`;
                }

                // If property has a structure ID, than retrive related data
                // and document archive
                if (this.propertyData.structure) {
                  this.subscriptions.push(
                    this.settingsService.getDocument().subscribe(
                      (res) => {
                        if (res.status) {
                          if (
                            res.data &&
                            Array.isArray(res.data) &&
                            res.data.length > 0 &&
                            res.data[0].area &&
                            Array.isArray(res.data[0].area)
                          ) {
                            this.documentTemplateId = res.data[0]._id;
                            this.documentTemplate = res.data[0].area;

                            this.documentsStructure = this.documentTemplate.map((elDT: any) => {
                              let subEl = [];
                              if (Array.isArray(elDT.content)) {
                                subEl = elDT.content.map((subElDT: any) => {
                                  return {
                                    title: subElDT.title,
                                    translation: subElDT.translation,
                                    type: subElDT.type,
                                    expanded: subElDT.expanded,
                                    section: subElDT.section,
                                    visible: subElDT.visible,
                                    key: subElDT.key,
                                  };
                                });
                              }
                              return {
                                title: elDT.title,
                                translation: elDT.translation,
                                type: elDT.type,
                                section: "",
                                buttonTitle: "",
                                expanded: elDT.expanded,
                                icon: "",
                                visible: elDT.visible,
                                content: subEl,
                              }
                            })
                            // Hide all visible elements of side menu
                            for (const key in this.documentsStructure) {
                              this.documentsStructure[key].visible = false;
                              if (Array.isArray(this.documentsStructure[key].content)) {
                                this.documentsStructure[key].content.forEach((el: any) => {
                                  el.visible = false;
                                });
                              }
                            }

                            this.getStructureData();
                          }
                        }
                      },
                      (err) => {
                        //
                      }
                    )
                  );
                } else {
                  this.documentArchiveIsLoading = false;
                }
                this.pageIsLoading = false;
                return;
              }

              // Something bad happened
              // redirect user to home
              this.router.navigate([this.lang, "app", "properties", "list"]);
            },
            err => {
              // if we came here users with given userId do not exist
              this.router.navigate([this.lang, "errors", "404"]);
            }
          )
        );
      }
    } else if (this.currentRole.type == "temporary") {
      // Get Property
      if (this.currentRole.propertiesPermission) {

        // Get requested property data
        this.propertyId = this.activatedRoute.snapshot.params.propertyId;

        // Get requested property data, company data and document archive
        this.subscriptions.push(
          this.propertiesService.get(this.propertyId).subscribe(
            res => {
              if (res.status) {
                this.property.setData(res.data);
                this.propertyData = res.data;

                if (
                  this.propertyData &&
                  this.propertyData.subscription &&
                  this.propertyData.subscription.key
                ) {
                  this.subscriptionType = this.propertyData.subscription.key;
                }

                if (this.propertyData.admin
                  && this.propertyData.admin.company
                  && this.propertyData.admin.company._id) {
                  this.subscriptions.push(
                    this.companiesService.get(this.propertyData.admin.company._id).subscribe(
                      res => {
                        if (res.status) {
                          this.company.setData(res.data);
                          this.companyAdmin = this.company.get("name");
                        }
                      })
                  )
                }
                this.companyOwner = "";
                if (this.propertyData.owner) {
                  this.subscriptions.push(
                    this.companiesService.get(this.propertyData.owner).subscribe(
                      res => {
                        if (res.status) {
                          this.company.setData(res.data);
                          this.companyOwner = this.company.get("name");
                        }
                      })
                  )
                }

                if (this.propertyData.address) {
                  this.address = `${this.propertyData.address.route},
                  ${this.propertyData.address.streetNumber} -
                  ${this.propertyData.address.postalCode}
                  ${this.propertyData.address.city}`;
                }

                // If property has a structure ID, than retrive related data
                // and document archive
                if (this.propertyData.structure) {
                  this.subscriptions.push(
                    this.settingsService.getDocument().subscribe(
                      (res) => {
                        if (res.status) {
                          if (
                            res.data &&
                            Array.isArray(res.data) &&
                            res.data.length > 0 &&
                            res.data[0].area &&
                            Array.isArray(res.data[0].area)
                          ) {
                            this.documentTemplateId = res.data[0]._id;
                            this.documentTemplate = res.data[0].area;

                            this.documentsStructure = this.documentTemplate.map((elDT: any) => {
                              let subEl = [];
                              if (Array.isArray(elDT.content)) {
                                subEl = elDT.content.map((subElDT: any) => {
                                  return {
                                    title: subElDT.title,
                                    translation: subElDT.translation,
                                    type: subElDT.type,
                                    expanded: subElDT.expanded,
                                    section: subElDT.section,
                                    visible: subElDT.visible,
                                    key: subElDT.key,
                                  };
                                });
                              }
                              return {
                                title: elDT.title,
                                translation: elDT.translation,
                                type: elDT.type,
                                section: "",
                                buttonTitle: "",
                                expanded: elDT.expanded,
                                icon: "",
                                visible: elDT.visible,
                                content: subEl,
                              }
                            })
                            // Hide all visible elements of side menu
                            for (const key in this.documentsStructure) {
                              this.documentsStructure[key].visible = false;
                              if (Array.isArray(this.documentsStructure[key].content)) {
                                this.documentsStructure[key].content.forEach((el: any) => {
                                  el.visible = false;
                                });
                              }
                            }

                            this.getStructureData();
                          }
                        }
                      },
                      (err) => {
                        //
                      }
                    )
                  );
                } else {
                  this.documentArchiveIsLoading = false;
                }
                this.pageIsLoading = false;
                return;
              }

              // Something bad happened
              // redirect user to home
              this.router.navigate([this.lang, "app", "properties", "list"]);
            },
            err => {
              // if we came here users with given userId do not exist
              this.router.navigate([this.lang, "errors", "404"]);
            }
          )
        );
      }
    }
  }

  /**
   * Get courrent property structure data and populate
   * this.condoStructure.
   * Then get archive document.
   *
   * @since 1.0.0
   */
  getStructureData(): void {
    this.condoStructuresService
      .get(this.property.get("structure"))
      .subscribe(res => {
        if (res.status) {
          this.condoStructure = res.data;
          if (this.condoStructure && !this.condoStructure.open) {
            this.condoStructureOpen =  false;
          }
          this.structureIsLoading = false;
          // If property has a document Archive ID, than retrive related data
          if (this.propertyData.documentArchive) {
            this.documentArchiveId = this.propertyData.documentArchive;
            this.getDocumentArchiveData2();
            this.pageIsLoading = false;

          }
        } else {
          this.documentArchiveIsLoading = false;
          this.structureIsLoading = false;
          this.toastrService.error(res.message);
        }
      });
  }


  /**
   * Get current property documentArchive data and populate
   * this.documentArchive
   * this.allDocs is used to show all docs in page
   *
   * @since 1.0.0
   */
  /**
   * Get current property documentArchive data and populate
   * this.documentArchive
   * this.allDocs is used to show all docs in page
   *
   * @since 1.0.0
   */
  getDocumentArchiveData(): void {
    this.documentArchiveIsLoading = true;
    this.insertedDocs = [];
    this.documentArchivesService
      .get(this.property.get("documentArchive"))
      .subscribe(res => {
        if (res.status) {
          this.documentArchive = res.data;

          // Costruisco l'oggetto di tutti i documenti inseriti in archivio
          //
          // GESTIONALE AMMINISTRATIVO
          //
          if ((typeof res.data.gestAmmTivoGestionali !== 'undefined'
            || res.data.gestAmmTivoDipendenti.length
            || typeof res.data.gestAmmTivoGestioneDipend !== 'undefined'
            || typeof res.data.gestAmmTivoGestioneRifiut !== 'undefined'
            || typeof res.data.gestAmmTivoBanca !== 'undefined'
            || typeof res.data.gestAmmTivoCauseLegali !== 'undefined'
            || typeof res.data.gestAmmTivoSicurezza !== 'undefined'
            || typeof res.data.gestAmmTivoAssicurazioni !== 'undefined'
            || typeof res.data.gestAmmTivoValutFornitori !== 'undefined'
            || typeof res.data.gestAmmTivoattoDiAcqven !== 'undefined'
            || typeof res.data.gestAmmTivovincoliEDiri !== 'undefined'
            || typeof res.data.gestAmmTivoipoteche !== 'undefined'
            || typeof res.data.gestAmmTivotitolarita !== 'undefined'
            || typeof res.data.gestAmmelaboratiGrafici !== 'undefined'
            || typeof res.data.gestAmmApe !== 'undefined')
            && this.currentRole.propertiesPermission.gestionaleAmministrativo) {

            const contents = [];
            if (typeof res.data.gestAmmTivoGestionali !== 'undefined') {
              const items = this.getDocsFromSection(res.data.gestAmmTivoGestionali);
              contents.push({
                title: this.translateService.instant("properties.documents.gestAmmTivoGestionali"),
                keyTranslateTitle: "properties.documents.gestAmmTivoGestionali",
                type: "doc",
                content: items
              });
            }
            if (res.data.gestAmmTivoDipendenti.length) {
              const items = res.data.gestAmmTivoDipendenti.map((elem: any) => {
                const structureName = this.condoStructure.dipendenti
                  ? this.condoStructure.dipendenti.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                return {
                  title: (structureName) ? structureName.nome + " " + structureName.cognome : "",
                  active: (structureName) ? structureName.active : false,
                  type: "title",
                  docId: elem._id,
                  structureId: elem.structureObjectId,
                  content: this.getDocsFromSection(elem),
                };
              });
              contents.push({
                title: this.translateService.instant("properties.documents.gestAmmTivoDipendenti"),
                keyTranslateTitle: "properties.documents.gestAmmTivoDipendenti",
                type: "title",
                content: items
              });
            }
            if (typeof res.data.gestAmmTivoGestioneDipend !== 'undefined') {
              const items = this.getDocsFromSection(res.data.gestAmmTivoGestioneDipend);
              contents.push({
                title: this.translateService.instant("properties.documents.gestAmmTivoGestioneDipend"),
                keyTranslateTitle: "properties.documents.gestAmmTivoGestioneDipend",
                type: "doc",
                content: items
              });
            }
            if (typeof res.data.gestAmmTivoGestioneRifiut !== 'undefined') {
              const items = this.getDocsFromSection(res.data.gestAmmTivoGestioneRifiut);
              contents.push({
                title: this.translateService.instant("properties.documents.gestAmmTivoGestioneRifiut"),
                keyTranslateTitle: "properties.documents.gestAmmTivoGestioneRifiut",
                type: "doc",
                content: items
              });
            }
            if (typeof res.data.gestAmmTivoBanca !== 'undefined') {
              const items = this.getDocsFromSection(res.data.gestAmmTivoBanca);
              contents.push({
                title: this.translateService.instant("properties.documents.gestAmmTivoBanca"),
                keyTranslateTitle: "properties.documents.gestAmmTivoBanca",
                type: "doc",
                content: items
              });
            }
            if (typeof res.data.gestAmmTivoCauseLegali !== 'undefined') {
              const items = this.getDocsFromSection(res.data.gestAmmTivoCauseLegali);
              const items2 = [];
              items.forEach((elem: any) => {
                const index = items2.findIndex((subElem: any) => {
                  return subElem.title === elem.data.nomeArchiviazioneIntervento;
                });
                if (index > -1) {
                  items2[index].content.push(elem);
                } else {
                  items2.push({
                    title: elem.data.nomeArchiviazioneIntervento,
                    active: true,
                    type: "title",
                    docId: undefined,
                    structureId: "",
                    content: [elem]
                  });
                }
              });
              if (items2.length) {
                contents.push({
                  title: this.translateService.instant("properties.documents.gestAmmTivoCauseLegali"),
                  keyTranslateTitle: "properties.documents.gestAmmTivoCauseLegali",
                  type: "title",
                  content: items2
                });
              }
            }

            if (typeof res.data.gestAmmTivoSicurezza !== 'undefined') {
              const items = this.getDocsFromSection(res.data.gestAmmTivoSicurezza);
              contents.push({
                title: this.translateService.instant("properties.documents.gestAmmTivoSicurezza"),
                keyTranslateTitle: "properties.documents.gestAmmTivoSicurezza",
                type: "doc",
                content: items
              });
            }
            if (typeof res.data.gestAmmTivoAssicurazioni !== 'undefined') {
              const items = this.getDocsFromSection(res.data.gestAmmTivoAssicurazioni);
              contents.push({
                title: this.translateService.instant("properties.documents.gestAmmTivoAssicurazioni"),
                keyTranslateTitle: "properties.documents.gestAmmTivoAssicurazioni",
                type: "doc",
                content: items
              });
            }
            if (typeof res.data.gestAmmTivoValutFornitori !== 'undefined') {
              const items = this.getDocsFromSection(res.data.gestAmmTivoValutFornitori);
              const items2 = [];
              items.forEach((elem: any) => {
                const index = items2.findIndex((subElem: any) => {
                  return subElem.title === elem.data.nomeFornitore;
                });
                if (index > -1) {
                  items2[index].content.push(elem);
                } else {
                  items2.push({
                    title: elem.data.nomeFornitore,
                    active: true,
                    type: "title",
                    docId: undefined,
                    structureId: "",
                    content: [elem]
                  });
                }
              });
              if (items2.length) {
                contents.push({
                  title: this.translateService.instant("properties.documents.gestAmmTivoValutFornitori"),
                  keyTranslateTitle: "properties.documents.gestAmmTivoValutFornitori",
                  type: "title",
                  content: items2
                });
              }
            }
            // EX GESTIONALE AMMINISTRATIVI IMMOBILE
            if (typeof res.data.gestAmmTivoattoDiAcqven !== 'undefined') {
              const items = this.getDocsFromSection(res.data.gestAmmTivoattoDiAcqven);
              contents.push({
                title: this.translateService.instant("properties.documents.gestAmmTivoattoDiAcqven"),
                keyTranslateTitle: "properties.documents.gestAmmTivoattoDiAcqven",
                type: "doc",
                content: items
              });
            }
            if (typeof res.data.gestAmmTivovincoliEDiri !== 'undefined') {
              const items = this.getDocsFromSection(res.data.gestAmmTivovincoliEDiri);
              contents.push({
                title: this.translateService.instant("properties.documents.gestAmmTivovincoliEDiri"),
                keyTranslateTitle: "properties.documents.gestAmmTivovincoliEDiri",
                type: "doc",
                content: items
              });
            }
            if (typeof res.data.gestAmmTivoipoteche !== 'undefined') {
              const items = this.getDocsFromSection(res.data.gestAmmTivoipoteche);
              contents.push({
                title: this.translateService.instant("properties.documents.gestAmmTivoipoteche"),
                keyTranslateTitle: "properties.documents.gestAmmTivoipoteche",
                type: "doc",
                content: items
              });
            }
            if (typeof res.data.gestAmmTivotitolarita !== 'undefined') {
              const items = this.getDocsFromSection(res.data.gestAmmTivotitolarita);
              contents.push({
                title: this.translateService.instant("properties.documents.gestAmmTivotitolarita"),
                keyTranslateTitle: "properties.documents.gestAmmTivotitolarita",
                type: "doc",
                content: items
              });
            }
            if (typeof res.data.gestAmmelaboratiGrafici !== 'undefined') {
              const items = this.getDocsFromSection(res.data.gestAmmelaboratiGrafici);
              contents.push({
                title: this.translateService.instant("properties.documents.gestAmmelaboratiGrafici"),
                keyTranslateTitle: "properties.documents.gestAmmelaboratiGrafici",
                type: "doc",
                content: items
              });
            }
            if (typeof res.data.gestAmmApe !== 'undefined') {
              const items = this.getDocsFromSection(res.data.gestAmmApe);
              contents.push({
                title: this.translateService.instant("properties.documents.gestAmmApe"),
                keyTranslateTitle: "properties.documents.gestAmmApe",
                type: "doc",
                content: items
              });
            }

            this.allDocs.push({
              keyTranslateTitle: "properties.documents.gestionaleAmministrativo",
              title: this.translateService.instant("properties.documents.gestionaleAmministrativo"),
              type: "title",
              content: contents
            })
          }
          //
          // GESTIONALE AMMINISTRATIVI IMMOBILE
          //
          // if (typeof res.data.gestAmmTivoattoDiAcqven !== 'undefined'
          //   || typeof res.data.gestAmmTivovincoliEDiri !== 'undefined'
          //   || typeof res.data.gestAmmTivoipoteche !== 'undefined'
          //   || typeof res.data.gestAmmTivotitolarita !== 'undefined'
          //   || typeof res.data.gestAmmelaboratiGrafici !== 'undefined'
          //   || typeof res.data.gestAmmApe !== 'undefined') {

          //   const contents = [];
          //   if (typeof res.data.gestAmmTivoattoDiAcqven !== 'undefined') {
          //     const items = this.getDocsFromSection(res.data.gestAmmTivoattoDiAcqven);
          //     contents.push({
          //       title: this.translateService.instant("properties.documents.gestAmmTivoattoDiAcqven"),
          //       keyTranslateTitle: "properties.documents.gestAmmTivoattoDiAcqven",
          //       type: "doc",
          //       content: items
          //     });
          //   }
          //   if (typeof res.data.gestAmmTivovincoliEDiri !== 'undefined') {
          //     const items = this.getDocsFromSection(res.data.gestAmmTivovincoliEDiri);
          //     contents.push({
          //       title: this.translateService.instant("properties.documents.gestAmmTivovincoliEDiri"),
          //       keyTranslateTitle: "properties.documents.gestAmmTivovincoliEDiri",
          //       type: "doc",
          //       content: items
          //     });
          //   }
          //   if (typeof res.data.gestAmmTivoipoteche !== 'undefined') {
          //     const items = this.getDocsFromSection(res.data.gestAmmTivoipoteche);
          //     contents.push({
          //       title: this.translateService.instant("properties.documents.gestAmmTivoipoteche"),
          //       keyTranslateTitle: "properties.documents.gestAmmTivoipoteche",
          //       type: "doc",
          //       content: items
          //     });
          //   }
          //   if (typeof res.data.gestAmmTivotitolarita !== 'undefined') {
          //     const items = this.getDocsFromSection(res.data.gestAmmTivotitolarita);
          //     contents.push({
          //       title: this.translateService.instant("properties.documents.gestAmmTivotitolarita"),
          //       keyTranslateTitle: "properties.documents.gestAmmTivotitolarita",
          //       type: "doc",
          //       content: items
          //     });
          //   }
          //   if (typeof res.data.gestAmmelaboratiGrafici !== 'undefined') {
          //     const items = this.getDocsFromSection(res.data.gestAmmelaboratiGrafici);
          //     contents.push({
          //       title: this.translateService.instant("properties.documents.gestAmmelaboratiGrafici"),
          //       keyTranslateTitle: "properties.documents.gestAmmelaboratiGrafici",
          //       type: "doc",
          //       content: items
          //     });
          //   }
          //   if (typeof res.data.gestAmmApe !== 'undefined') {
          //     const items = this.getDocsFromSection(res.data.gestAmmApe);
          //     contents.push({
          //       title: this.translateService.instant("properties.documents.gestAmmApe"),
          //       keyTranslateTitle: "properties.documents.gestAmmApe",
          //       type: "doc",
          //       content: items
          //     });
          //   }

          //   this.allDocs.push({
          //     keyTranslateTitle: "properties.documents.amministrativiImmobile",
          //     title: this.translateService.instant("properties.documents.amministrativiImmobile"),
          //     type: "title",
          //     content: contents
          //   })
          // }

          //
          // CATASTO
          //
          if ((typeof res.data.catastoCatastoTerreni !== 'undefined'
            || typeof res.data.catastoCatastoFabbricati !== 'undefined')
            && this.currentRole.propertiesPermission.catasto) {
            const contents = [];
            if (typeof res.data.catastoCatastoTerreni !== 'undefined') {
              const items = this.getDocsFromSection(res.data.catastoCatastoTerreni);
              contents.push({
                title: this.translateService.instant("properties.documents.catastoCatastoTerreni"),
                keyTranslateTitle: "properties.documents.catastoCatastoTerreni",
                type: "doc",
                content: items
              });
            }
            if (typeof res.data.catastoCatastoFabbricati !== 'undefined') {
              const items = this.getDocsFromSection(res.data.catastoCatastoFabbricati);
              contents.push({
                title: this.translateService.instant("properties.documents.catastoCatastoFabbricati"),
                keyTranslateTitle: "properties.documents.catastoCatastoFabbricati",
                type: "doc",
                content: items
              });
            }
            this.allDocs.push({
              keyTranslateTitle: "properties.documents.catasto",
              title: this.translateService.instant("properties.documents.catasto"),
              type: "title",
              content: contents
            })
          }

          //
          // URBANISTICA ED EDILIZIA
          //
          if ((typeof res.data.urbedilurbanistedEdili !== 'undefined'
            || typeof res.data.urbedilcondoni !== 'undefined'
            || typeof res.data.urbedilautorizzazioni !== 'undefined')
            && this.currentRole.propertiesPermission.urbanisticaEdEdilizia) {
            const contents = [];
            if (typeof res.data.urbedilurbanistedEdili !== 'undefined') {
              const items = this.getDocsFromSection(res.data.urbedilurbanistedEdili);
              contents.push({
                title: this.translateService.instant("properties.documents.urbedilurbanistedEdili"),
                keyTranslateTitle: "properties.documents.urbedilurbanistedEdili",
                type: "doc",
                content: items
              });
            }
            if (typeof res.data.urbedilcondoni !== 'undefined') {
              const items = this.getDocsFromSection(res.data.urbedilcondoni);
              contents.push({
                title: this.translateService.instant("properties.documents.urbedilcondoni"),
                keyTranslateTitle: "properties.documents.urbedilcondoni",
                type: "doc",
                content: items
              });
            }
            if (typeof res.data.urbedilautorizzazioni !== 'undefined') {
              const items = this.getDocsFromSection(res.data.urbedilautorizzazioni);
              contents.push({
                title: this.translateService.instant("properties.documents.urbedilautorizzazioni"),
                keyTranslateTitle: "properties.documents.urbedilautorizzazioni",
                type: "doc",
                content: items
              });
            }
            this.allDocs.push({
              keyTranslateTitle: "properties.documents.urbanisticaEdEdilizia",
              title: this.translateService.instant("properties.documents.urbanisticaEdEdilizia"),
              type: "title",
              content: contents
            })
          }

          //
          // STACKINGPLAN
          //
          if (typeof res.data.stackingPlan !== 'undefined') {
            const contents = [];
            if (typeof res.data.stackingPlan !== 'undefined') {
              const items = this.getDocsFromSection(res.data.stackingPlan);
              contents.push({
                title: this.translateService.instant("properties.documents.stackingPlan"),
                keyTranslateTitle: "properties.documents.stackingPlan",
                type: "doc",
                content: items
              });
            }
            this.allDocs.push({
              keyTranslateTitle: "properties.documents.stackingPlan",
              title: this.translateService.instant("properties.documents.stackingPlan"),
              type: "title",
              content: contents
            })
          }

          //
          // REPORTISTICA
          //
          if (typeof res.data.reportistica !== 'undefined') {
            const contents = [];
            if (typeof res.data.reportistica !== 'undefined') {
              const items = this.getDocsFromSection(res.data.reportistica);
              contents.push({
                title: this.translateService.instant("properties.documents.reportistica"),
                keyTranslateTitle: "properties.documents.reportistica",
                type: "doc",
                content: items
              });
            }
            this.allDocs.push({
              keyTranslateTitle: "properties.documents.reportistica",
              title: this.translateService.instant("properties.documents.reportistica"),
              type: "title",
              content: contents
            })
          }

          //
          // CONTRATTI DI LOCAZIONE
          //
          if (typeof res.data.locazioneContrdiLocazione !== 'undefined') {
            const contents = [];
            if (typeof res.data.locazioneContrdiLocazione !== 'undefined') {
              const items = this.getDocsFromSection(res.data.locazioneContrdiLocazione);
              const items2 = [];
              items.forEach((elem: any) => {
                const index = items2.findIndex((subElem: any) => {
                  return subElem.title === elem.data.nomeConduttore;
                });
                if (index > -1) {
                  items2[index].content.push(elem);
                } else {
                  items2.push({
                    title: elem.data.nomeConduttore,
                    active: true,
                    type: "title",
                    docId: undefined,
                    structureId: "",
                    content: [elem]
                  });
                }
              });
              if (items2.length) {
                contents.push({
                  title: this.translateService.instant("properties.documents.locazioneContrdiLocazione"),
                  keyTranslateTitle: "properties.documents.locazioneContrdiLocazione",
                  type: "title",
                  content: items2
                });
              }
            }

            this.allDocs.push({
              keyTranslateTitle: "properties.documents.locazioneContrdiLocazione",
              title: this.translateService.instant("properties.documents.locazioneContrdiLocazione"),
              type: "title",
              content: contents
            })
          }

          if (this.currentRole.propertiesPermission.contratti) {
            const contents = [];
            const itemsContract = [];
            itemsContract.push({
              title: "",
              active: true,
              type: "title",
              docId: "",
              structureId: "",
              content: [],
            })

            if (res.data.contratti.length) {
              res.data.contratti.forEach((elem: any) => {
                let subDocs = [];
                let active = true;
                let title = "";
                if (elem.structureObjectId === "-1") {//contratti generici
                  subDocs = this.getDocsFromContractSection(elem, "properties.documents.contratti");
                  //title = this.translateService.instant("properties.documents.genericContracts");
                  title = "";
                } else {
                  const structure = this.condoStructure[elem.structureObjectType]
                    ? this.condoStructure[elem.structureObjectType].find((item: any) => {
                      return item._id === elem.structureObjectId;
                    })
                    : undefined;
                  if (structure && structure.active) {
                    if (typeof structure.codicePod !== "undefined" && structure.codicePod !== "") {
                      title = structure.codicePod;
                    } else {
                      if (structure.nome) {
                        title = structure.nome;
                      }
                    }
                    subDocs = this.getDocsFromContractSection(elem, "properties.documents.contratti");
                  } else {
                    active = false;
                    title = "";
                  }
                }
                subDocs.forEach((subElem: any) => {
                  const element = {
                    structureTitle: title,
                    structureId: elem.structureObjectId,
                    active: active,
                    documentId: elem._id,
                    ...subElem
                  }
                  itemsContract[0].content.push(element);
                });
              });
            }

            let subDocs = [];
            let active = true;
            let title = "";
            if (typeof res.data.gestAmmTivoGestionali !== 'undefined') {
              subDocs = this.getDocsFromContractSection(res.data.gestAmmTivoGestionali, "properties.documents.gestAmmTivoGestionali");
              subDocs.forEach((subElem: any) => {
                const element = {
                  structureTitle: "",
                  structureId: "-1",
                  active: true,
                  documentId: "",
                  ...subElem
                }
                itemsContract[0].content.push(element);
              });
            }
            if (typeof res.data.gestAmmTivoAssicurazioni !== 'undefined') {
              subDocs = this.getDocsFromContractSection(res.data.gestAmmTivoAssicurazioni, "properties.documents.gestAmmTivoAssicurazioni");
              subDocs.forEach((subElem: any) => {
                const element = {
                  structureTitle: "",
                  structureId: "-1",
                  active: true,
                  documentId: "",
                  ...subElem
                }
                itemsContract[0].content.push(element);
              });
            }
            if (typeof res.data.impelegenerale !== "undefined") {
              subDocs = this.getDocsFromContractSection(res.data.impelegenerale, "properties.documents.impelegenerale");
              subDocs.forEach((subElem: any) => {
                const element = {
                  structureTitle: "",
                  structureId: "-1",
                  active: true,
                  documentId: "",
                  ...subElem
                }
                itemsContract[0].content.push(element);
              });
            }
            if (typeof res.data.tratAcquaReteIdricaSanitari !== 'undefined') {
              subDocs = this.getDocsFromContractSection(res.data.tratAcquaReteIdricaSanitari, "properties.documents.tratAcquaReteIdricaSanitari");
              subDocs.forEach((subElem: any) => {
                const element = {
                  structureTitle: "",
                  structureId: "-1",
                  active: true,
                  documentId: "",
                  ...subElem
                }
                itemsContract[0].content.push(element);
              });
            }
            if (res.data.tratAcquaCentraleIdrica.length) {
              res.data.tratAcquaCentraleIdrica.forEach((elem: any) => {
                const structureName = this.condoStructure.centraleIdricaPropria
                  ? this.condoStructure.centraleIdricaPropria.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                title = (structureName) ? structureName.nome : "";
                active = (structureName) ? structureName.active : false;
                subDocs = this.getDocsFromContractSection(elem, "properties.documents.tratAcquaCentraleIdrica");
                subDocs.forEach((subElem: any) => {
                  const element = {
                    structureTitle: title,
                    structureId: elem.structureObjectId,
                    active: active,
                    documentId: elem._id,
                    ...subElem
                  }
                  itemsContract[0].content.push(element);
                });
              });
            }
            if (res.data.tratAcquaSottAlimDaBsc.length) {
              res.data.tratAcquaSottAlimDaBsc.forEach((elem: any) => {
                const structureName = this.condoStructure.sottostazioneAltroCondBsc
                  ? this.condoStructure.sottostazioneAltroCondBsc.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                title = (structureName) ? structureName.nome : "";
                active = (structureName) ? structureName.active : false;
                subDocs = this.getDocsFromContractSection(elem, "properties.documents.tratAcquaSottAlimDaBsc");
                subDocs.forEach((subElem: any) => {
                  const element = {
                    structureTitle: title,
                    structureId: elem.structureObjectId,
                    active: active,
                    documentId: elem._id,
                    ...subElem
                  }
                  itemsContract[0].content.push(element);
                });
              });
            }
            if (typeof res.data.gestAmmTivoGestioneDipend !== 'undefined') {
              subDocs = this.getDocsFromContractSection(res.data.gestAmmTivoGestioneDipend, "properties.documents.gestAmmTivoGestioneDipend");
              subDocs.forEach((subElem: any) => {
                const element = {
                  structureTitle: "",
                  structureId: "-1",
                  active: true,
                  documentId: "",
                  ...subElem
                }
                itemsContract[0].content.push(element);
              });
            }
            if (typeof res.data.gestAmmTivoBanca !== 'undefined') {
              subDocs = this.getDocsFromContractSection(res.data.gestAmmTivoBanca, "properties.documents.gestAmmTivoBanca");
              subDocs.forEach((subElem: any) => {
                const element = {
                  structureTitle: "",
                  structureId: "-1",
                  active: true,
                  documentId: "",
                  ...subElem
                }
                itemsContract[0].content.push(element);
              });
            }
            if (typeof res.data.impeleMediaTensione !== 'undefined') {
              subDocs = this.getDocsFromContractSection(res.data.impeleMediaTensione, "properties.documents.impeleMediaTensione");
              subDocs.forEach((subElem: any) => {
                const element = {
                  structureTitle: "",
                  structureId: "-1",
                  active: true,
                  documentId: "",
                  ...subElem
                }
                itemsContract[0].content.push(element);
              });
            }
            if (res.data.incendioReteSprinkler.length) {
              res.data.incendioReteSprinkler.forEach((elem: any) => {
                const structureName = this.condoStructure.reteSprinkler
                  ? this.condoStructure.reteSprinkler.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                title = (structureName) ? structureName.nome : "";
                active = (structureName) ? structureName.active : false;
                subDocs = this.getDocsFromContractSection(elem, "properties.documents.incendioReteSprinkler");
                subDocs.forEach((subElem: any) => {
                  const element = {
                    structureTitle: title,
                    structureId: elem.structureObjectId,
                    active: active,
                    documentId: elem._id,
                    ...subElem
                  }
                  itemsContract[0].content.push(element);
                });
              });
            }
            if (res.data.incendioReteIdranti.length) {
              res.data.incendioReteIdranti.forEach((elem: any) => {
                const structureName = this.condoStructure.reteIdranti
                  ? this.condoStructure.reteIdranti.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                title = (structureName) ? structureName.nome : "";
                active = (structureName) ? structureName.active : false;
                subDocs = this.getDocsFromContractSection(elem, "properties.documents.incendioReteIdranti");
                subDocs.forEach((subElem: any) => {
                  const element = {
                    structureTitle: title,
                    structureId: elem.structureObjectId,
                    active: active,
                    documentId: elem._id,
                    ...subElem
                  }
                  itemsContract[0].content.push(element);
                });
              });
            }
            if (res.data.tratAcquaContatoreAcqua.length) {
              res.data.tratAcquaContatoreAcqua.forEach((elem: any) => {
                const structureName = this.condoStructure.contatoriAcqua
                  ? this.condoStructure.contatoriAcqua.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                title = (structureName) ? structureName.nome : "";
                active = (structureName) ? structureName.active : false;
                subDocs = this.getDocsFromContractSection(elem, "properties.documents.tratAcquaContatoreAcqua");
                subDocs.forEach((subElem: any) => {
                  const element = {
                    structureTitle: title,
                    structureId: elem.structureObjectId,
                    active: active,
                    documentId: elem._id,
                    ...subElem
                  }
                  itemsContract[0].content.push(element);
                });
              });
            }
            if (res.data.riscaldgasMetcontatrete.length) {
              res.data.riscaldgasMetcontatrete.forEach((elem: any) => {
                const structureName = this.condoStructure.contatoreGas
                  ? this.condoStructure.contatoreGas.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                title = (structureName) ? structureName.nome : "";
                active = (structureName) ? structureName.active : false;
                subDocs = this.getDocsFromContractSection(elem, "properties.documents.riscaldgasMetcontatrete");
                subDocs.forEach((subElem: any) => {
                  const element = {
                    structureTitle: title,
                    structureId: elem.structureObjectId,
                    active: active,
                    documentId: elem._id,
                    ...subElem
                  }
                  itemsContract[0].content.push(element);
                });
              });
            }
            if (res.data.serbatoioAGasolio.length) {
              res.data.serbatoioAGasolio.forEach((elem: any) => {
                const structureName = this.condoStructure.serbatoiAGasolio
                  ? this.condoStructure.serbatoiAGasolio.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                title = (structureName) ? structureName.nome : "";
                active = (structureName) ? structureName.active : false;
                subDocs = this.getDocsFromContractSection(elem, "properties.documents.serbatoioAGasolio");
                subDocs.forEach((subElem: any) => {
                  const element = {
                    structureTitle: title,
                    structureId: elem.structureObjectId,
                    active: active,
                    documentId: elem._id,
                    ...subElem
                  }
                  itemsContract[0].content.push(element);
                });
              });
            }
            if (res.data.riscaldrisccentraliz.length) {
              res.data.riscaldrisccentraliz.forEach((elem: any) => {
                const structureName = this.condoStructure.centraleTermica
                  ? this.condoStructure.centraleTermica.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                title = (structureName) ? structureName.nome : "";
                active = (structureName) ? structureName.active : false;
                subDocs = this.getDocsFromContractSection(elem, "properties.documents.riscaldrisccentraliz");
                subDocs.forEach((subElem: any) => {
                  const element = {
                    structureTitle: title,
                    structureId: elem.structureObjectId,
                    active: active,
                    documentId: elem._id,
                    ...subElem
                  }
                  itemsContract[0].content.push(element);
                });
              });
            }
            if (res.data.riscaldcentrteleriscaldamen.length) {
              res.data.riscaldcentrteleriscaldamen.forEach((elem: any) => {
                const structureName = this.condoStructure.teleriscaldamento
                  ? this.condoStructure.teleriscaldamento.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                title = (structureName) ? structureName.nome : "";
                active = (structureName) ? structureName.active : false;
                subDocs = this.getDocsFromContractSection(elem, "properties.documents.riscaldcentrteleriscaldamen");
                subDocs.forEach((subElem: any) => {
                  const element = {
                    structureTitle: title,
                    structureId: elem.structureObjectId,
                    active: active,
                    documentId: elem._id,
                    ...subElem
                  }
                  itemsContract[0].content.push(element);
                });
              });
            }
            if (res.data.riscGeotermicoPozzi.length) {
              res.data.riscGeotermicoPozzi.forEach((elem: any) => {
                const structureName = this.condoStructure.geotermicoConPozzi
                  ? this.condoStructure.geotermicoConPozzi.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                title = (structureName) ? structureName.nome : "";
                active = (structureName) ? structureName.active : false;
                subDocs = this.getDocsFromContractSection(elem, "properties.documents.riscGeotermicoPozzi");
                subDocs.forEach((subElem: any) => {
                  const element = {
                    structureTitle: title,
                    structureId: elem.structureObjectId,
                    active: active,
                    documentId: elem._id,
                    ...subElem
                  }
                  itemsContract[0].content.push(element);
                });
              });
            }
            if (res.data.riscGeotermicoSonde.length) {
              res.data.riscGeotermicoSonde.forEach((elem: any) => {
                const structureName = this.condoStructure.geotermicoConSonde
                  ? this.condoStructure.geotermicoConSonde.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                title = (structureName) ? structureName.nome : "";
                active = (structureName) ? structureName.active : false;
                subDocs = this.getDocsFromContractSection(elem, "properties.documents.riscGeotermicoSonde");
                subDocs.forEach((subElem: any) => {
                  const element = {
                    structureTitle: title,
                    structureId: elem.structureObjectId,
                    active: active,
                    documentId: elem._id,
                    ...subElem
                  }
                  itemsContract[0].content.push(element);
                });
              });
            }
            if (res.data.riscaldsoloPompeDiCalore.length) {
              res.data.riscaldsoloPompeDiCalore.forEach((elem: any) => {
                const structureName = this.condoStructure.pompeDiCalore
                  ? this.condoStructure.pompeDiCalore.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                title = (structureName) ? structureName.nome : "";
                active = (structureName) ? structureName.active : false;
                subDocs = this.getDocsFromContractSection(elem, "properties.documents.riscaldsoloPompeDiCalore");
                subDocs.forEach((subElem: any) => {
                  const element = {
                    structureTitle: title,
                    structureId: elem.structureObjectId,
                    active: active,
                    documentId: elem._id,
                    ...subElem
                  }
                  itemsContract[0].content.push(element);
                });
              });
            }
            if (res.data.riscaldcentrRicevBsc.length) {
              res.data.riscaldcentrRicevBsc.forEach((elem: any) => {
                const structureName = this.condoStructure.centraleRicervimento
                  ? this.condoStructure.centraleRicervimento.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                title = (structureName) ? structureName.nome : "";
                active = (structureName) ? structureName.active : false;
                subDocs = this.getDocsFromContractSection(elem, "properties.documents.riscaldcentrRicevBsc");
                subDocs.forEach((subElem: any) => {
                  const element = {
                    structureTitle: title,
                    structureId: elem.structureObjectId,
                    active: active,
                    documentId: elem._id,
                    ...subElem
                  }
                  itemsContract[0].content.push(element);
                });
              });
            }
            if (res.data.ascensoriEMontautoAscensori.length) {
              res.data.ascensoriEMontautoAscensori.forEach((elem: any) => {
                const structureName = this.condoStructure.ascensore
                  ? this.condoStructure.ascensore.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                title = (structureName) ? structureName.nome : "";
                active = (structureName) ? structureName.active : false;
                subDocs = this.getDocsFromContractSection(elem, "properties.documents.ascensoriEMontautoAscensori");
                subDocs.forEach((subElem: any) => {
                  const element = {
                    structureTitle: title,
                    structureId: elem.structureObjectId,
                    active: active,
                    documentId: elem._id,
                    ...subElem
                  }
                  itemsContract[0].content.push(element);
                });
              });
            }
            if (res.data.ascensoriEMontautoMontauto.length) {
              res.data.ascensoriEMontautoMontauto.forEach((elem: any) => {
                const structureName = this.condoStructure.montauto
                  ? this.condoStructure.montauto.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                title = (structureName) ? structureName.nome : "";
                active = (structureName) ? structureName.active : false;
                subDocs = this.getDocsFromContractSection(elem, "properties.documents.ascensoriEMontautoMontauto");
                subDocs.forEach((subElem: any) => {
                  const element = {
                    structureTitle: title,
                    structureId: elem.structureObjectId,
                    active: active,
                    documentId: elem._id,
                    ...subElem
                  }
                  itemsContract[0].content.push(element);
                });
              });
            }
            if (res.data.incendioEstintori.length) {
              res.data.incendioEstintori.forEach((elem: any) => {
                const structureName = this.condoStructure.estintori
                  ? this.condoStructure.estintori.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                // title = this.translateService.instant("properties.documents.incendioEstintori");
                title = (structureName) ? structureName.nome : "";
                active = (structureName) ? structureName.active : false;
                subDocs = this.getDocsFromContractSection(elem, "properties.documents.incendioEstintori");
                subDocs.forEach((subElem: any) => {
                  const element = {
                    structureTitle: title,
                    structureId: elem.structureObjectId,
                    active: active,
                    documentId: elem._id,
                    ...subElem
                  }
                  itemsContract[0].content.push(element);
                });
              });
            }
            if (res.data.incendioStazionePompaggio.length) {
              res.data.incendioStazionePompaggio.forEach((elem: any) => {
                const structureName = this.condoStructure.stazionePompaggio
                  ? this.condoStructure.stazionePompaggio.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                title = (structureName) ? structureName.nome : "";
                active = (structureName) ? structureName.active : false;
                subDocs = this.getDocsFromContractSection(elem, "properties.documents.incendioStazionePompaggio");
                subDocs.forEach((subElem: any) => {
                  const element = {
                    structureTitle: title,
                    structureId: elem.structureObjectId,
                    active: active,
                    documentId: elem._id,
                    ...subElem
                  }
                  itemsContract[0].content.push(element);
                });
              });
            }
            if (typeof res.data.edileporteRei !== 'undefined') {
              subDocs = this.getDocsFromContractSection(res.data.edileporteRei, "properties.documents.edileporteRei");
              subDocs.forEach((subElem: any) => {
                const element = {
                  structureTitle: "",
                  structureId: "-1",
                  active: true,
                  documentId: "",
                  ...subElem
                }
                itemsContract[0].content.push(element);
              });
            }
            if (res.data.incendioRilevazione.length) {
              res.data.incendioRilevazione.forEach((elem: any) => {
                const structureName = this.condoStructure.rilevazioneFumi
                  ? this.condoStructure.rilevazioneFumi.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                title = (structureName) ? structureName.nome : "";
                active = (structureName) ? structureName.active : false;
                subDocs = this.getDocsFromContractSection(elem, "properties.documents.incendioRilevazione");
                subDocs.forEach((subElem: any) => {
                  const element = {
                    structureTitle: title,
                    structureId: elem.structureObjectId,
                    active: active,
                    documentId: elem._id,
                    ...subElem
                  }
                  itemsContract[0].content.push(element);
                });
              });
            }
            if (res.data.incendioVentilazione.length) {
              res.data.incendioVentilazione.forEach((elem: any) => {
                const structureName = this.condoStructure.ventilazione
                  ? this.condoStructure.ventilazione.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                title = (structureName) ? structureName.nome : "";
                active = (structureName) ? structureName.active : false;
                subDocs = this.getDocsFromContractSection(elem, "properties.documents.incendioVentilazione");
                subDocs.forEach((subElem: any) => {
                  const element = {
                    structureTitle: title,
                    structureId: elem.structureObjectId,
                    active: active,
                    documentId: elem._id,
                    ...subElem
                  }
                  itemsContract[0].content.push(element);
                });
              });
            }
            if (res.data.riscaldimpcondizionamento.length) {
              res.data.riscaldimpcondizionamento.forEach((elem: any) => {
                const structureName = this.condoStructure.climatizzazione
                  ? this.condoStructure.climatizzazione.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                title = (structureName) ? structureName.nome : "";
                active = (structureName) ? structureName.active : false;
                subDocs = this.getDocsFromContractSection(elem, "properties.documents.riscaldimpcondizionamento");
                subDocs.forEach((subElem: any) => {
                  const element = {
                    structureTitle: title,
                    structureId: elem.structureObjectId,
                    active: active,
                    documentId: elem._id,
                    ...subElem
                  }
                  itemsContract[0].content.push(element);
                });
              });
            }
            if (res.data.impElettroniciautomazioni.length) {
              res.data.impElettroniciautomazioni.forEach((elem: any) => {
                const structureName = this.condoStructure.automazCancelli
                  ? this.condoStructure.automazCancelli.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                title = (structureName) ? structureName.nome : "";
                active = (structureName) ? structureName.active : false;
                subDocs = this.getDocsFromContractSection(elem, "properties.documents.impElettroniciautomazioni");
                subDocs.forEach((subElem: any) => {
                  const element = {
                    structureTitle: title,
                    structureId: elem.structureObjectId,
                    active: active,
                    documentId: elem._id,
                    ...subElem
                  }
                  itemsContract[0].content.push(element);
                });
              });
            }
            if (res.data.lineaVita.length) {
              res.data.lineaVita.forEach((elem: any) => {
                const structureName = this.condoStructure.lineeVita
                  ? this.condoStructure.lineeVita.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                title = (structureName) ? structureName.nome : "";
                active = (structureName) ? structureName.active : false;
                subDocs = this.getDocsFromContractSection(elem, "properties.documents.lineaVita");
                subDocs.forEach((subElem: any) => {
                  const element = {
                    structureTitle: title,
                    structureId: elem.structureObjectId,
                    active: active,
                    documentId: elem._id,
                    ...subElem
                  }
                  itemsContract[0].content.push(element);
                });
              });
            }
            if (typeof res.data.amiantoDoc !== 'undefined') {
              subDocs = this.getDocsFromContractSection(res.data.amiantoDoc, "properties.documents.amiantoDoc");
              subDocs.forEach((subElem: any) => {
                const element = {
                  structureTitle: "",
                  structureId: "-1",
                  active: true,
                  documentId: "",
                  ...subElem
                }
                itemsContract[0].content.push(element);
              });
            }
            if (res.data.impeleGruppoElettrogeno.length) {
              res.data.impeleGruppoElettrogeno.forEach((elem: any) => {
                const structureName = this.condoStructure.gruppoElettrogeno
                  ? this.condoStructure.gruppoElettrogeno.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                title = (structureName) ? structureName.nome : "";
                active = (structureName) ? structureName.active : false;
                subDocs = this.getDocsFromContractSection(elem, "properties.documents.impeleGruppoElettrogeno");
                subDocs.forEach((subElem: any) => {
                  const element = {
                    structureTitle: title,
                    structureId: elem.structureObjectId,
                    active: active,
                    documentId: elem._id,
                    ...subElem
                  }
                  itemsContract[0].content.push(element);
                });
              });
            }
            if (res.data.tratAcquaPompSollacqpiov.length) {
              res.data.tratAcquaPompSollacqpiov.forEach((elem: any) => {
                const structureName = this.condoStructure.sollevamAcquePiovNere
                  ? this.condoStructure.sollevamAcquePiovNere.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                title = (structureName) ? structureName.nome : "";
                active = (structureName) ? structureName.active : false;
                subDocs = this.getDocsFromContractSection(elem, "properties.documents.tratAcquaPompSollacqpiov");
                subDocs.forEach((subElem: any) => {
                  const element = {
                    structureTitle: title,
                    structureId: elem.structureObjectId,
                    active: active,
                    documentId: elem._id,
                    ...subElem
                  }
                  itemsContract[0].content.push(element);
                });
              });
            }
            if (res.data.impeleFotovoltaico.length) {
              res.data.impeleFotovoltaico.forEach((elem: any) => {
                const structureName = this.condoStructure.fotovoltaico
                  ? this.condoStructure.fotovoltaico.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                title = (structureName) ? structureName.nome : "";
                active = (structureName) ? structureName.active : false;
                subDocs = this.getDocsFromContractSection(elem, "properties.documents.impeleFotovoltaico");
                subDocs.forEach((subElem: any) => {
                  const element = {
                    structureTitle: title,
                    structureId: elem.structureObjectId,
                    active: active,
                    documentId: elem._id,
                    ...subElem
                  }
                  itemsContract[0].content.push(element);
                });
              });
            }
            if (res.data.impelescaricheAtmosferiche.length) {
              res.data.impelescaricheAtmosferiche.forEach((elem: any) => {
                const structureName = this.condoStructure.scaricheAtmosferiche
                  ? this.condoStructure.scaricheAtmosferiche.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                title = (structureName) ? structureName.nome : "";
                active = (structureName) ? structureName.active : false;
                subDocs = this.getDocsFromContractSection(elem, "properties.documents.impelescaricheAtmosferiche");
                subDocs.forEach((subElem: any) => {
                  const element = {
                    structureTitle: title,
                    structureId: elem.structureObjectId,
                    active: active,
                    documentId: elem._id,
                    ...subElem
                  }
                  itemsContract[0].content.push(element);
                });
              });
            }
            if (res.data.impElettroniciimpCitofonico.length) {
              res.data.impElettroniciimpCitofonico.forEach((elem: any) => {
                const structureName = this.condoStructure.citoVideo
                  ? this.condoStructure.citoVideo.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                title = (structureName) ? structureName.nome : "";
                active = (structureName) ? structureName.active : false;
                subDocs = this.getDocsFromContractSection(elem, "properties.documents.impElettroniciimpCitofonico");
                subDocs.forEach((subElem: any) => {
                  const element = {
                    structureTitle: title,
                    structureId: elem.structureObjectId,
                    active: active,
                    documentId: elem._id,
                    ...subElem
                  }
                  itemsContract[0].content.push(element);
                });
              });
            }
            if (res.data.impElettroniciimpiantoTvcc.length) {
              res.data.impElettroniciimpiantoTvcc.forEach((elem: any) => {
                const structureName = this.condoStructure.tvCc
                  ? this.condoStructure.tvCc.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                title = (structureName) ? structureName.nome : "";
                active = (structureName) ? structureName.active : false;
                subDocs = this.getDocsFromContractSection(elem, "properties.documents.impElettroniciimpiantoTvcc");
                subDocs.forEach((subElem: any) => {
                  const element = {
                    structureTitle: title,
                    structureId: elem.structureObjectId,
                    active: active,
                    documentId: elem._id,
                    ...subElem
                  }
                  itemsContract[0].content.push(element);
                });
              });
            }
            if (res.data.impElettroniciantintrusione.length) {
              res.data.impElettroniciantintrusione.forEach((elem: any) => {
                const structureName = this.condoStructure.impAntintrusione
                  ? this.condoStructure.impAntintrusione.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                title = (structureName) ? structureName.nome : "";
                active = (structureName) ? structureName.active : false;
                subDocs = this.getDocsFromContractSection(elem, "properties.documents.impElettroniciantintrusione");
                subDocs.forEach((subElem: any) => {
                  const element = {
                    structureTitle: title,
                    structureId: elem.structureObjectId,
                    active: active,
                    documentId: elem._id,
                    ...subElem
                  }
                  itemsContract[0].content.push(element);
                });
              });
            }
            if (res.data.impricreativipiscina.length) {
              res.data.impricreativipiscina.forEach((elem: any) => {
                const structureName = this.condoStructure.piscina
                  ? this.condoStructure.piscina.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                title = (structureName) ? structureName.nome : "";
                active = (structureName) ? structureName.active : false;
                subDocs = this.getDocsFromContractSection(elem, "properties.documents.impricreativipiscina");
                subDocs.forEach((subElem: any) => {
                  const element = {
                    structureTitle: title,
                    structureId: elem.structureObjectId,
                    active: active,
                    documentId: elem._id,
                    ...subElem
                  }
                  itemsContract[0].content.push(element);
                });
              });
            }
            if (res.data.impElettronicitvTerrestre.length) {
              res.data.impElettronicitvTerrestre.forEach((elem: any) => {
                const structureName = this.condoStructure.tvTerrestre
                  ? this.condoStructure.tvTerrestre.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                title = (structureName) ? structureName.nome : "";
                active = (structureName) ? structureName.active : false;
                subDocs = this.getDocsFromContractSection(elem, "properties.documents.impElettronicitvTerrestre");
                subDocs.forEach((subElem: any) => {
                  const element = {
                    structureTitle: title,
                    structureId: elem.structureObjectId,
                    active: active,
                    documentId: elem._id,
                    ...subElem
                  }
                  itemsContract[0].content.push(element);
                });
              });
            }
            if (res.data.impElettronicitvSatellitare.length) {
              res.data.impElettronicitvSatellitare.forEach((elem: any) => {
                const structureName = this.condoStructure.tvSatellitare
                  ? this.condoStructure.tvSatellitare.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                title = (structureName) ? structureName.nome : "";
                active = (structureName) ? structureName.active : false;
                subDocs = this.getDocsFromContractSection(elem, "properties.documents.impElettronicitvSatellitare");
                subDocs.forEach((subElem: any) => {
                  const element = {
                    structureTitle: title,
                    structureId: elem.structureObjectId,
                    active: active,
                    documentId: elem._id,
                    ...subElem
                  }
                  itemsContract[0].content.push(element);
                });
              });
            }
            if (res.data.riscaldsolareTermico.length) {
              res.data.riscaldsolareTermico.forEach((elem: any) => {
                const structureName = this.condoStructure.solareTermico
                  ? this.condoStructure.solareTermico.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                title = (structureName) ? structureName.nome : "";
                active = (structureName) ? structureName.active : false;
                subDocs = this.getDocsFromContractSection(elem, "properties.documents.riscaldsolareTermico");
                subDocs.forEach((subElem: any) => {
                  const element = {
                    structureTitle: title,
                    structureId: elem.structureObjectId,
                    active: active,
                    documentId: elem._id,
                    ...subElem
                  }
                  itemsContract[0].content.push(element);
                });
              });
            }
            if (typeof res.data.edilestrutture !== 'undefined') {
              subDocs = this.getDocsFromContractSection(res.data.edilestrutture, "properties.documents.edilestrutture");
              subDocs.forEach((subElem: any) => {
                const element = {
                  structureTitle: "",
                  structureId: "-1",
                  active: true,
                  documentId: "",
                  ...subElem
                }
                itemsContract[0].content.push(element);
              });
            }
            if (typeof res.data.edileinterventiSuccessivi !== 'undefined') {
              subDocs = this.getDocsFromContractSection(res.data.edileinterventiSuccessivi, "properties.documents.edileinterventiSuccessivi");
              subDocs.forEach((subElem: any) => {
                const element = {
                  structureTitle: "",
                  structureId: "-1",
                  active: true,
                  documentId: "",
                  ...subElem
                }
                itemsContract[0].content.push(element);
              });
            }
            if (typeof res.data.edilereteFognaria !== 'undefined') {
              subDocs = this.getDocsFromContractSection(res.data.edilereteFognaria, "properties.documents.edilereteFognaria");
              subDocs.forEach((subElem: any) => {
                const element = {
                  structureTitle: "",
                  structureId: "-1",
                  active: true,
                  documentId: "",
                  ...subElem
                }
                itemsContract[0].content.push(element);
              });
            }

            if (itemsContract[0].content.length) {
              itemsContract[0].content.sort(this.compareExpired);
              contents.push({
                title: this.translateService.instant("properties.documents.contratti"),
                keyTranslateTitle: "properties.documents.contratti",
                type: "contract",
                content: itemsContract
              });

              this.allDocs.push({
                keyTranslateTitle: "properties.documents.contratti",
                title: this.translateService.instant("properties.documents.contratti"),
                type: "title",
                content: contents
              })
            }
          }

          //
          // LINEA VITA
          //
          if (typeof res.data.lineaVita !== 'undefined' && res.data.lineaVita.length
            && this.currentRole.propertiesPermission.lineaVita) {
            const contents = [];
            if (res.data.lineaVita.length) {
              const items = res.data.lineaVita.map((elem: any) => {
                const structureName = this.condoStructure.lineeVita
                  ? this.condoStructure.lineeVita.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                return {
                  title: (structureName) ? structureName.nome : "",
                  active: (structureName) ? structureName.active : false,
                  type: "title",
                  docId: elem._id,
                  structureId: elem.structureObjectId,
                  content: this.getDocsFromSection(elem),
                };
              });
              contents.push({
                title: this.translateService.instant("properties.documents.lineaVita"),
                keyTranslateTitle: "properties.documents.lineaVita",
                type: "title",
                content: items
              });
            }
            this.allDocs.push({
              keyTranslateTitle: "properties.documents.lineaVita",
              title: this.translateService.instant("properties.documents.lineaVita"),
              type: "title",
              content: contents
            })
          }

          //
          // AMIANTO
          //
          if (typeof res.data.amiantoDoc !== 'undefined'
            && this.currentRole.propertiesPermission.amiantoDoc) {
            const contents = [];
            if (typeof res.data.amiantoDoc !== 'undefined') {
              const items = this.getDocsFromSection(res.data.amiantoDoc);
              contents.push({
                title: this.translateService.instant("properties.documents.amiantoDoc"),
                keyTranslateTitle: "properties.documents.amiantoDoc",
                type: "doc",
                content: items
              });
            }
            this.allDocs.push({
              keyTranslateTitle: "properties.documents.amiantoDoc",
              title: this.translateService.instant("properties.documents.amiantoDoc"),
              type: "title",
              content: contents
            })
          }

          //
          // EDILE
          //
          if ((typeof res.data.ediledocumentiDiCostruz !== 'undefined'
            || typeof res.data.edilemuratureRei !== 'undefined'
            || typeof res.data.edileporteRei !== 'undefined'
            || typeof res.data.edileinterventiSuccessivi !== 'undefined'
            || typeof res.data.edilestrutture !== 'undefined'
            || typeof res.data.edilereteFognaria !== 'undefined')
            && this.currentRole.propertiesPermission.edile) {
            const contents = [];
            if (typeof res.data.ediledocumentiDiCostruz !== 'undefined') {
              const items = this.getDocsFromSection(res.data.ediledocumentiDiCostruz);
              contents.push({
                title: this.translateService.instant("properties.documents.ediledocumentiDiCostruz"),
                keyTranslateTitle: "properties.documents.ediledocumentiDiCostruz",
                type: "doc",
                content: items
              });
            }
            if (typeof res.data.edilemuratureRei !== 'undefined') {
              const items = this.getDocsFromSection(res.data.edilemuratureRei);
              contents.push({
                title: this.translateService.instant("properties.documents.edilemuratureRei"),
                keyTranslateTitle: "properties.documents.edilemuratureRei",
                type: "doc",
                content: items
              });
            }
            if (typeof res.data.edileporteRei !== 'undefined') {
              const items = this.getDocsFromSection(res.data.edileporteRei);
              contents.push({
                title: this.translateService.instant("properties.documents.edileporteRei"),
                keyTranslateTitle: "",
                type: "doc",
                content: items
              });
            }
            if (typeof res.data.edileinterventiSuccessivi !== 'undefined') {
              const items = this.getDocsFromSection(res.data.edileinterventiSuccessivi);
              // contents.push({
              //   title: this.translateService.instant("properties.documents.edileinterventiSuccessivi"),
              //   keyTranslateTitle: "properties.documents.edileinterventiSuccessivi",
              //   type: "doc",
              //   content: items
              // });

              const items2 = [];
              items.forEach((elem: any) => {
                const index = items2.findIndex((subElem: any) => {
                  return subElem.title === elem.data.nomeArchiviazioneIntervento;
                });
                if (index > -1) {
                  items2[index].content.push(elem);
                } else {
                  items2.push({
                    title: elem.data.nomeArchiviazioneIntervento,
                    active: true,
                    type: "title",
                    docId: undefined,
                    structureId: "",
                    content: [elem]
                  });
                }
              });
              if (items2.length) {
                contents.push({
                  title: this.translateService.instant("properties.documents.edileinterventiSuccessivi"),
                  keyTranslateTitle: "properties.documents.edileinterventiSuccessivi",
                  type: "title",
                  content: items2
                });
              }
            }
            if (typeof res.data.edilestrutture !== 'undefined') {
              const items = this.getDocsFromSection(res.data.edilestrutture);
              contents.push({
                title: this.translateService.instant("properties.documents.edilestrutture"),
                keyTranslateTitle: "properties.documents.edilestrutture",
                type: "doc",
                content: items
              });
            }
            if (typeof res.data.edilereteFognaria !== 'undefined') {
              const items = this.getDocsFromSection(res.data.edilereteFognaria);
              contents.push({
                title: this.translateService.instant("properties.documents.edilereteFognaria"),
                keyTranslateTitle: "properties.documents.edilereteFognaria",
                type: "doc",
                content: items
              });
            }
            this.allDocs.push({
              keyTranslateTitle: "properties.documents.edile",
              title: this.translateService.instant("properties.documents.edile"),
              type: "title",
              content: contents
            });
          }

          //
          // IMPIANTI ELETTRICI
          //
          if ((typeof res.data.impelegenerale !== 'undefined'
            || typeof res.data.impeleMediaTensione !== 'undefined'
            || res.data.impeleGruppoElettrogeno.length
            || res.data.impeleFotovoltaico.length
            || res.data.impelescaricheAtmosferiche.length)
            && this.currentRole.propertiesPermission.impiantoElettrico) {
            const contents = [];
            // if (res.data.impelegenerale.length) {
            //   const items = res.data.impelegenerale.map((elem: any) => {
            //     const structureName = this.condoStructure.fornituraBt
            //       ? this.condoStructure.fornituraBt.find((item: any) => {
            //         return item._id === elem.structureObjectId;
            //       })
            //       : undefined;
            //     return {
            //       title: (structureName) ? structureName.nome : "",
            //       active: (structureName) ? structureName.active : false,
            //       type: "title",
            //       docId: elem._id,
            //       structureId: elem.structureObjectId,
            //       content: this.getDocsFromSection(elem),
            //     };
            //   });
            //   contents.push({
            //     title: this.translateService.instant("properties.documents.impelegenerale"),
            //     keyTranslateTitle: "properties.documents.impelegenerale",
            //     type: "title",
            //     content: items
            //   });
            // }
            if (typeof res.data.impelegenerale !== 'undefined') {
              const items = this.getDocsFromSection(res.data.impelegenerale);
              contents.push({
                title: this.translateService.instant("properties.documents.impelegenerale"),
                keyTranslateTitle: "properties.documents.impelegenerale",
                type: "doc",
                content: items
              });
            }

            // if (res.data.impeleMediaTensione.length) {
            //   const items = res.data.impeleMediaTensione.map((elem: any) => {
            //     const structureName = this.condoStructure.fornituraMt
            //       ? this.condoStructure.fornituraMt.find((item: any) => {
            //         return item._id === elem.structureObjectId;
            //       })
            //       : undefined;
            //     return {
            //       title: (structureName) ? structureName.nome : "",
            //       active: (structureName) ? structureName.active : false,
            //       type: "title",
            //       docId: elem._id,
            //       structureId: elem.structureObjectId,
            //       content: this.getDocsFromSection(elem),
            //     };
            //   });
            //   contents.push({
            //     title: this.translateService.instant("properties.documents.impeleMediaTensione"),
            //     keyTranslateTitle: "properties.documents.impeleMediaTensione",
            //     type: "title",
            //     content: items
            //   });
            // }
            if (typeof res.data.impeleMediaTensione !== 'undefined') {
              const items = this.getDocsFromSection(res.data.impeleMediaTensione);
              contents.push({
                title: this.translateService.instant("properties.documents.impeleMediaTensione"),
                keyTranslateTitle: "properties.documents.impeleMediaTensione",
                type: "doc",
                content: items
              });
            }

            if (res.data.impeleGruppoElettrogeno.length) {
              const items = res.data.impeleGruppoElettrogeno.map((elem: any) => {
                const structureName = this.condoStructure.gruppoElettrogeno
                  ? this.condoStructure.gruppoElettrogeno.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                return {
                  title: (structureName) ? structureName.nome : "",
                  active: (structureName) ? structureName.active : false,
                  type: "title",
                  docId: elem._id,
                  structureId: elem.structureObjectId,
                  content: this.getDocsFromSection(elem),
                };
              });
              contents.push({
                title: this.translateService.instant("properties.documents.impeleGruppoElettrogeno"),
                keyTranslateTitle: "properties.documents.impeleGruppoElettrogeno",
                type: "title",
                content: items
              });
            }
            if (res.data.impeleFotovoltaico.length) {
              const items = res.data.impeleFotovoltaico.map((elem: any) => {
                const structureName = this.condoStructure.fotovoltaico
                  ? this.condoStructure.fotovoltaico.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                return {
                  title: (structureName) ? structureName.nome : "",
                  active: (structureName) ? structureName.active : false,
                  type: "title",
                  docId: elem._id,
                  structureId: elem.structureObjectId,
                  content: this.getDocsFromSection(elem),
                };
              });
              contents.push({
                title: this.translateService.instant("properties.documents.impeleFotovoltaico"),
                keyTranslateTitle: "properties.documents.impeleFotovoltaico",
                type: "title",
                content: items
              });
            }
            if (res.data.impelescaricheAtmosferiche.length) {
              const items = res.data.impelescaricheAtmosferiche.map((elem: any) => {
                const structureName = this.condoStructure.scaricheAtmosferiche
                  ? this.condoStructure.scaricheAtmosferiche.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                return {
                  title: (structureName) ? structureName.nome : "",
                  active: (structureName) ? structureName.active : false,
                  type: "title",
                  docId: elem._id,
                  structureId: elem.structureObjectId,
                  content: this.getDocsFromSection(elem),
                };
              });
              contents.push({
                title: this.translateService.instant("properties.documents.impelescaricheAtmosferiche"),
                keyTranslateTitle: "properties.documents.impelescaricheAtmosferiche",
                type: "title",
                content: items
              });
            }

            this.allDocs.push({
              keyTranslateTitle: "properties.documents.impiantoElettrico",
              title: this.translateService.instant("properties.documents.impiantoElettrico"),
              type: "title",
              content: contents
            });
          }

          //
          // RISCALDAMENTO/CONDIZIONAMENTO
          //
          if ((res.data.riscaldrisccentraliz.length
            || res.data.serbatoioAGasolio.length
            || res.data.riscaldgasMetcontatrete.length
            || res.data.riscaldsottostazriscaldamen.length
            || res.data.riscaldcanneFumariePerCt.length
            || res.data.riscaldsolareTermico.length
            || res.data.riscaldcentrteleriscaldamen.length
            || res.data.riscGeotermicoPozzi.length
            || res.data.riscGeotermicoSonde.length
            || res.data.riscaldsoloPompeDiCalore.length
            || res.data.riscaldcentrRicevBsc.length
            || res.data.riscaldimpcondizionamento.length
            || (typeof res.data.risccanneFumarieColl !== "undefined"
              && res.data.risccanneFumarieColl.length))
            && this.currentRole.propertiesPermission.riscaldamentoCondizionamento) {
            const contents = [];
            if (res.data.riscaldgasMetcontatrete.length) {
              const items = res.data.riscaldgasMetcontatrete.map((elem: any) => {
                const structureName = this.condoStructure.contatoreGas
                  ? this.condoStructure.contatoreGas.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                return {
                  title: (structureName) ? structureName.nome : "",
                  active: (structureName) ? structureName.active : false,
                  type: "title",
                  docId: elem._id,
                  structureId: elem.structureObjectId,
                  content: this.getDocsFromSection(elem),
                };
              });
              contents.push({
                title: this.translateService.instant("properties.documents.riscaldgasMetcontatrete"),
                keyTranslateTitle: "properties.documents.riscaldgasMetcontatrete",
                type: "title",
                content: items
              });
            }
            if (res.data.riscaldrisccentraliz.length) {
              const items = res.data.riscaldrisccentraliz.map((elem: any) => {
                const structureName = this.condoStructure.centraleTermica
                  ? this.condoStructure.centraleTermica.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                return {
                  title: (structureName) ? structureName.nome : "",
                  active: (structureName) ? structureName.active : false,
                  type: "title",
                  docId: elem._id,
                  structureId: elem.structureObjectId,
                  content: this.getDocsFromSection(elem),
                };
              });
              contents.push({
                title: this.translateService.instant("properties.documents.riscaldrisccentraliz"),
                keyTranslateTitle: "properties.documents.riscaldrisccentraliz",
                type: "title",
                content: items
              });
            }
            if (res.data.serbatoioAGasolio.length) {
              const items = res.data.serbatoioAGasolio.map((elem: any) => {
                const structureName = this.condoStructure.serbatoiAGasolio
                  ? this.condoStructure.serbatoiAGasolio.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                return {
                  title: (structureName) ? structureName.nome : "",
                  active: (structureName) ? structureName.active : false,
                  type: "title",
                  docId: elem._id,
                  structureId: elem.structureObjectId,
                  content: this.getDocsFromSection(elem),
                };
              });
              contents.push({
                title: this.translateService.instant("properties.documents.serbatoioAGasolio"),
                keyTranslateTitle: "properties.documents.serbatoioAGasolio",
                type: "title",
                content: items
              });
            }
            if (res.data.riscaldsottostazriscaldamen.length) {
              const items = res.data.riscaldsottostazriscaldamen.map((elem: any) => {
                const structureName = this.condoStructure.sottostazioniCt
                  ? this.condoStructure.sottostazioniCt.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                return {
                  title: (structureName) ? structureName.nome : "",
                  active: (structureName) ? structureName.active : false,
                  type: "title",
                  docId: elem._id,
                  structureId: elem.structureObjectId,
                  content: this.getDocsFromSection(elem),
                };
              });
              contents.push({
                title: this.translateService.instant("properties.documents.riscaldsottostazriscaldamen"),
                keyTranslateTitle: "properties.documents.riscaldsottostazriscaldamen",
                type: "title",
                content: items
              });
            }
            if (res.data.riscaldcanneFumariePerCt.length) {
              const items = res.data.riscaldcanneFumariePerCt.map((elem: any) => {
                const structureName = this.condoStructure.cannaFumaria
                  ? this.condoStructure.cannaFumaria.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                return {
                  title: (structureName) ? structureName.nome : "",
                  active: (structureName) ? structureName.active : false,
                  type: "title",
                  docId: elem._id,
                  structureId: elem.structureObjectId,
                  content: this.getDocsFromSection(elem),
                };
              });
              contents.push({
                title: this.translateService.instant("properties.documents.riscaldcanneFumariePerCt"),
                keyTranslateTitle: "properties.documents.riscaldcanneFumariePerCt",
                type: "title",
                content: items
              });
            }
            if (res.data.riscaldsolareTermico.length) {
              const items = res.data.riscaldsolareTermico.map((elem: any) => {
                const structureName = this.condoStructure.solareTermico
                  ? this.condoStructure.solareTermico.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                return {
                  title: (structureName) ? structureName.nome : "",
                  active: (structureName) ? structureName.active : false,
                  type: "title",
                  docId: elem._id,
                  structureId: elem.structureObjectId,
                  content: this.getDocsFromSection(elem),
                };
              });
              contents.push({
                title: this.translateService.instant("properties.documents.riscaldsolareTermico"),
                keyTranslateTitle: "properties.documents.riscaldsolareTermico",
                type: "title",
                content: items
              });
            }
            if (res.data.riscaldcentrteleriscaldamen.length) {
              const items = res.data.riscaldcentrteleriscaldamen.map((elem: any) => {
                const structureName = this.condoStructure.teleriscaldamento
                  ? this.condoStructure.teleriscaldamento.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                return {
                  title: (structureName) ? structureName.nome : "",
                  active: (structureName) ? structureName.active : false,
                  type: "title",
                  docId: elem._id,
                  structureId: elem.structureObjectId,
                  content: this.getDocsFromSection(elem),
                };
              });
              contents.push({
                title: this.translateService.instant("properties.documents.riscaldcentrteleriscaldamen"),
                keyTranslateTitle: "properties.documents.riscaldcentrteleriscaldamen",
                type: "title",
                content: items
              });
            }
            if (res.data.riscGeotermicoPozzi.length) {
              const items = res.data.riscGeotermicoPozzi.map((elem: any) => {
                const structureName = this.condoStructure.geotermicoConPozzi
                  ? this.condoStructure.geotermicoConPozzi.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                return {
                  title: (structureName) ? structureName.nome : "",
                  active: (structureName) ? structureName.active : false,
                  type: "title",
                  docId: elem._id,
                  structureId: elem.structureObjectId,
                  content: this.getDocsFromSection(elem),
                };
              });
              contents.push({
                title: this.translateService.instant("properties.documents.riscGeotermicoPozzi"),
                keyTranslateTitle: "properties.documents.riscGeotermicoPozzi",
                type: "title",
                content: items
              });
            }
            if (res.data.riscGeotermicoSonde.length) {
              const items = res.data.riscGeotermicoSonde.map((elem: any) => {
                const structureName = this.condoStructure.geotermicoConSonde
                  ? this.condoStructure.geotermicoConSonde.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                return {
                  title: (structureName) ? structureName.nome : "",
                  active: (structureName) ? structureName.active : false,
                  type: "title",
                  docId: elem._id,
                  structureId: elem.structureObjectId,
                  content: this.getDocsFromSection(elem),
                };
              });
              contents.push({
                title: this.translateService.instant("properties.documents.riscGeotermicoSonde"),
                keyTranslateTitle: "properties.documents.riscGeotermicoSonde",
                type: "title",
                content: items
              });
            }
            if (res.data.riscaldsoloPompeDiCalore.length) {
              const items = res.data.riscaldsoloPompeDiCalore.map((elem: any) => {
                const structureName = this.condoStructure.pompeDiCalore
                  ? this.condoStructure.pompeDiCalore.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                return {
                  title: (structureName) ? structureName.nome : "",
                  active: (structureName) ? structureName.active : false,
                  type: "title",
                  docId: elem._id,
                  structureId: elem.structureObjectId,
                  content: this.getDocsFromSection(elem),
                };
              });
              contents.push({
                title: this.translateService.instant("properties.documents.riscaldsoloPompeDiCalore"),
                keyTranslateTitle: "properties.documents.riscaldsoloPompeDiCalore",
                type: "title",
                content: items
              });
            }
            if (res.data.riscaldcentrRicevBsc.length) {
              const items = res.data.riscaldcentrRicevBsc.map((elem: any) => {
                const structureName = this.condoStructure.centraleRicervimento
                  ? this.condoStructure.centraleRicervimento.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                return {
                  title: (structureName) ? structureName.nome : "",
                  active: (structureName) ? structureName.active : false,
                  type: "title",
                  docId: elem._id,
                  structureId: elem.structureObjectId,
                  content: this.getDocsFromSection(elem),
                };
              });
              contents.push({
                title: this.translateService.instant("properties.documents.riscaldcentrRicevBsc"),
                keyTranslateTitle: "properties.documents.riscaldcentrRicevBsc",
                type: "title",
                content: items
              });
            }
            if (res.data.riscaldimpcondizionamento.length) {
              const items = res.data.riscaldimpcondizionamento.map((elem: any) => {
                const structureName = this.condoStructure.climatizzazione
                  ? this.condoStructure.climatizzazione.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                return {
                  title: (structureName) ? structureName.nome : "",
                  active: (structureName) ? structureName.active : false,
                  type: "title",
                  docId: elem._id,
                  structureId: elem.structureObjectId,
                  content: this.getDocsFromSection(elem),
                };
              });
              contents.push({
                title: this.translateService.instant("properties.documents.riscaldimpcondizionamento"),
                keyTranslateTitle: "properties.documents.riscaldimpcondizionamento",
                type: "title",
                content: items
              });
            }
            if ((typeof res.data.risccanneFumarieColl !== "undefined"
              && res.data.risccanneFumarieColl.length)) {
              const items = res.data.risccanneFumarieColl.map((elem: any) => {
                const structureName = this.condoStructure.cannaCollettiva
                  ? this.condoStructure.cannaCollettiva.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                return {
                  title: (structureName) ? structureName.nome : "",
                  active: (structureName) ? structureName.active : false,
                  type: "title",
                  docId: elem._id,
                  structureId: elem.structureObjectId,
                  content: this.getDocsFromSection(elem),
                };
              });
              contents.push({
                title: this.translateService.instant("properties.documents.risccanneFumarieColl"),
                keyTranslateTitle: "properties.documents.risccanneFumarieColl",
                type: "title",
                content: items
              });
            }

            this.allDocs.push({
              keyTranslateTitle: "properties.documents.riscaldamentoCondizionamento",
              title: this.translateService.instant("properties.documents.riscaldamentoCondizionamento"),
              type: "title",
              content: contents
            })
          }

          //
          // ASCENSORI E MONTAUTO
          //
          if ((res.data.ascensoriEMontautoAscensori.length
            || res.data.ascensoriEMontautoMontauto.length)
            && this.currentRole.propertiesPermission.ascensori) {
            const contents = [];
            if (res.data.ascensoriEMontautoAscensori.length) {
              const items = res.data.ascensoriEMontautoAscensori.map((elem: any) => {
                const structureName = this.condoStructure.ascensore
                  ? this.condoStructure.ascensore.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                return {
                  title: (structureName) ? structureName.nome : "",
                  active: (structureName) ? structureName.active : false,
                  type: "title",
                  docId: elem._id,
                  structureId: elem.structureObjectId,
                  content: this.getDocsFromSection(elem),
                };
              });
              contents.push({
                title: this.translateService.instant("properties.documents.ascensoriEMontautoAscensori"),
                keyTranslateTitle: "properties.documents.ascensoriEMontautoAscensori",
                type: "title",
                content: items
              });
            }
            if (res.data.ascensoriEMontautoMontauto.length) {
              const items = res.data.ascensoriEMontautoMontauto.map((elem: any) => {
                const structureName = this.condoStructure.montauto
                  ? this.condoStructure.montauto.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                return {
                  title: (structureName) ? structureName.nome : "",
                  active: (structureName) ? structureName.active : false,
                  type: "title",
                  docId: elem._id,
                  structureId: elem.structureObjectId,
                  content: this.getDocsFromSection(elem),
                };
              });
              contents.push({
                title: this.translateService.instant("properties.documents.ascensoriEMontautoMontauto"),
                keyTranslateTitle: "properties.documents.ascensoriEMontautoMontauto",
                type: "title",
                content: items
              });
            }

            this.allDocs.push({
              keyTranslateTitle: "properties.documents.ascensoriEMontauto",
              title: this.translateService.instant("properties.documents.ascensoriEMontauto"),
              type: "title",
              content: contents
            })
          }

          //
          // TRATTAMENTO ACQUA
          //
          if ((res.data.tratAcquaContatoreAcqua.length
            || res.data.tratAcquaCentraleIdrica.length
            || res.data.tratAcquaSottAlimDaBsc.length
            || res.data.tratAcquaPompSollacqpiov.length
            || typeof res.data.tratAcquaReteIdricaSanitari !== 'undefined')
            && this.currentRole.propertiesPermission.trattamentoAcqua) {
            const contents = [];
            if (res.data.tratAcquaContatoreAcqua.length) {
              const items = res.data.tratAcquaContatoreAcqua.map((elem: any) => {
                const structureName = this.condoStructure.contatoriAcqua
                  ? this.condoStructure.contatoriAcqua.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                return {
                  title: (structureName) ? structureName.nome : "",
                  active: (structureName) ? structureName.active : false,
                  type: "title",
                  docId: elem._id,
                  structureId: elem.structureObjectId,
                  content: this.getDocsFromSection(elem),
                };
              });
              contents.push({
                title: this.translateService.instant("properties.documents.tratAcquaContatoreAcqua"),
                keyTranslateTitle: "properties.documents.tratAcquaContatoreAcqua",
                type: "title",
                content: items
              });
            }
            if (res.data.tratAcquaCentraleIdrica.length) {
              const items = res.data.tratAcquaCentraleIdrica.map((elem: any) => {
                const structureName = this.condoStructure.centraleIdricaPropria
                  ? this.condoStructure.centraleIdricaPropria.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                return {
                  title: (structureName) ? structureName.nome : "",
                  active: (structureName) ? structureName.active : false,
                  type: "title",
                  docId: elem._id,
                  structureId: elem.structureObjectId,
                  content: this.getDocsFromSection(elem),
                };
              });
              contents.push({
                title: this.translateService.instant("properties.documents.tratAcquaCentraleIdrica"),
                keyTranslateTitle: "properties.documents.tratAcquaCentraleIdrica",
                type: "title",
                content: items
              });
            }
            if (res.data.tratAcquaSottAlimDaBsc.length) {
              const items = res.data.tratAcquaSottAlimDaBsc.map((elem: any) => {
                const structureName = this.condoStructure.sottostazioneAltroCondBsc
                  ? this.condoStructure.sottostazioneAltroCondBsc.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                return {
                  title: (structureName) ? structureName.nome : "",
                  active: (structureName) ? structureName.active : false,
                  type: "title",
                  docId: elem._id,
                  structureId: elem.structureObjectId,
                  content: this.getDocsFromSection(elem),
                };
              });
              contents.push({
                title: this.translateService.instant("properties.documents.tratAcquaSottAlimDaBsc"),
                keyTranslateTitle: "properties.documents.tratAcquaSottAlimDaBsc",
                type: "title",
                content: items
              });
            }
            if (res.data.tratAcquaPompSollacqpiov.length) {
              const items = res.data.tratAcquaPompSollacqpiov.map((elem: any) => {
                const structureName = this.condoStructure.sollevamAcquePiovNere
                  ? this.condoStructure.sollevamAcquePiovNere.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                return {
                  title: (structureName) ? structureName.nome : "",
                  active: (structureName) ? structureName.active : false,
                  type: "title",
                  docId: elem._id,
                  structureId: elem.structureObjectId,
                  content: this.getDocsFromSection(elem),
                };
              });
              contents.push({
                title: this.translateService.instant("properties.documents.tratAcquaPompSollacqpiov"),
                keyTranslateTitle: "properties.documents.tratAcquaPompSollacqpiov",
                type: "title",
                content: items
              });
            }
            if (typeof res.data.tratAcquaReteIdricaSanitari !== 'undefined') {
              const items = this.getDocsFromSection(res.data.tratAcquaReteIdricaSanitari);
              contents.push({
                title: this.translateService.instant("properties.documents.tratAcquaReteIdricaSanitari"),
                keyTranslateTitle: "properties.documents.tratAcquaReteIdricaSanitari",
                type: "doc",
                content: items
              });
            }

            this.allDocs.push({
              keyTranslateTitle: "properties.documents.trattamentoAcqua",
              title: this.translateService.instant("properties.documents.trattamentoAcqua"),
              type: "title",
              content: contents
            })
          }

          //
          // IMPIANTO ELETTRONICO
          //
          if ((res.data.impElettronicitvTerrestre.length
            || res.data.impElettronicitvSatellitare.length
            || res.data.impElettroniciautomazioni.length
            || res.data.impElettroniciimpCitofonico.length
            || res.data.impElettroniciimpiantoTvcc.length
            || res.data.impElettroniciantintrusione.length)
            && this.currentRole.propertiesPermission.impiantiElettronici) {
            const contents = [];
            if (res.data.impElettronicitvTerrestre.length) {
              const items = res.data.impElettronicitvTerrestre.map((elem: any) => {
                const structureName = this.condoStructure.tvTerrestre
                  ? this.condoStructure.tvTerrestre.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                return {
                  title: (structureName) ? structureName.nome : "",
                  active: (structureName) ? structureName.active : false,
                  type: "title",
                  docId: elem._id,
                  structureId: elem.structureObjectId,
                  content: this.getDocsFromSection(elem),
                };
              });
              contents.push({
                title: this.translateService.instant("properties.documents.impElettronicitvTerrestre"),
                keyTranslateTitle: "properties.documents.impElettronicitvTerrestre",
                type: "title",
                content: items
              });
            }
            if (res.data.impElettronicitvSatellitare.length) {
              const items = res.data.impElettronicitvSatellitare.map((elem: any) => {
                const structureName = this.condoStructure.tvSatellitare
                  ? this.condoStructure.tvSatellitare.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                return {
                  title: (structureName) ? structureName.nome : "",
                  active: (structureName) ? structureName.active : false,
                  type: "title",
                  docId: elem._id,
                  structureId: elem.structureObjectId,
                  content: this.getDocsFromSection(elem),
                };
              });
              contents.push({
                title: this.translateService.instant("properties.documents.impElettronicitvSatellitare"),
                keyTranslateTitle: "properties.documents.impElettronicitvSatellitare",
                type: "title",
                content: items
              });
            }
            if (res.data.impElettroniciautomazioni.length) {
              const items = res.data.impElettroniciautomazioni.map((elem: any) => {
                const structureName = this.condoStructure.automazCancelli
                  ? this.condoStructure.automazCancelli.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                return {
                  title: (structureName) ? structureName.nome : "",
                  active: (structureName) ? structureName.active : false,
                  type: "title",
                  docId: elem._id,
                  structureId: elem.structureObjectId,
                  content: this.getDocsFromSection(elem),
                };
              });
              contents.push({
                title: this.translateService.instant("properties.documents.impElettroniciautomazioni"),
                keyTranslateTitle: "properties.documents.impElettroniciautomazioni",
                type: "title",
                content: items
              });
            }
            if (res.data.impElettroniciimpCitofonico.length) {
              const items = res.data.impElettroniciimpCitofonico.map((elem: any) => {
                const structureName = this.condoStructure.citoVideo
                  ? this.condoStructure.citoVideo.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                return {
                  title: (structureName) ? structureName.nome : "",
                  active: (structureName) ? structureName.active : false,
                  type: "title",
                  docId: elem._id,
                  structureId: elem.structureObjectId,
                  content: this.getDocsFromSection(elem),
                };
              });
              contents.push({
                title: this.translateService.instant("properties.documents.impElettroniciimpCitofonico"),
                keyTranslateTitle: "properties.documents.impElettroniciimpCitofonico",
                type: "title",
                content: items
              });
            }
            if (res.data.impElettroniciimpiantoTvcc.length) {
              const items = res.data.impElettroniciimpiantoTvcc.map((elem: any) => {
                const structureName = this.condoStructure.tvCc
                  ? this.condoStructure.tvCc.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                return {
                  title: (structureName) ? structureName.nome : "",
                  active: (structureName) ? structureName.active : false,
                  type: "title",
                  docId: elem._id,
                  structureId: elem.structureObjectId,
                  content: this.getDocsFromSection(elem),
                };
              });
              contents.push({
                title: this.translateService.instant("properties.documents.impElettroniciimpiantoTvcc"),
                keyTranslateTitle: "properties.documents.impElettroniciimpiantoTvcc",
                type: "title",
                content: items
              });
            }
            if (res.data.impElettroniciantintrusione.length) {
              const items = res.data.impElettroniciantintrusione.map((elem: any) => {
                const structureName = this.condoStructure.impAntintrusione
                  ? this.condoStructure.impAntintrusione.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                return {
                  title: (structureName) ? structureName.nome : "",
                  active: (structureName) ? structureName.active : false,
                  type: "title",
                  docId: elem._id,
                  structureId: elem.structureObjectId,
                  content: this.getDocsFromSection(elem),
                };
              });
              contents.push({
                title: this.translateService.instant("properties.documents.impElettroniciantintrusione"),
                keyTranslateTitle: "properties.documents.impElettroniciantintrusione",
                type: "title",
                content: items
              });
            }

            this.allDocs.push({
              keyTranslateTitle: "properties.documents.impiantiElettronici",
              title: this.translateService.instant("properties.documents.impiantiElettronici"),
              type: "title",
              content: contents
            })
          }

          //
          // PRATICA PREVENZIONE INCENDI
          //
          if (typeof res.data.vvFdefinitivo !== "undefined"
            && res.data.vvFdefinitivo.length
            && this.currentRole.propertiesPermission.antincendio) {
            const vvF = [];
            const contents = [];
            const items = res.data.vvFdefinitivo.map((elem: any) => {
              if (elem.structureObjectId === "-1") {//doc  generici
                return {
                  title: this.translateService.instant("properties.documents.genericVVF"),
                  active: true,//(structureName) ? structureName.active : false,
                  type: "title",
                  docId: elem._id,
                  structureId: elem.structureObjectId,
                  content: this.getDocsFromSection(elem),
                  structureObjectType: "-1",
                };
              } else {
                const structureName = this.condoStructure[elem.structureObjectType]
                  ? this.condoStructure[elem.structureObjectType].find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                return {
                  title: elem.structureObjectName,
                  active: (structureName) ? structureName.active : false,
                  type: "title",
                  docId: elem._id,
                  structureId: elem.structureObjectId,
                  content: this.getDocsFromSection(elem),
                  structureObjectType: elem.structureObjectType
                };
              }
            });
            const itemsOrdered = [];
            // fabbricatoAbitativo 77
            items.forEach((elem: any) => {
              if (elem.structureObjectType === "fabbricatoAbitativo") {
                itemsOrdered.push(elem);
              }
            });
            // compartimentoBox 75
            items.forEach((elem: any) => {
              if (elem.structureObjectType === "compartimentoBox") {
                itemsOrdered.push(elem);
              }
            });
            // centraleTermica 75
            items.forEach((elem: any) => {
              if (elem.structureObjectType === "centraleTermica") {
                itemsOrdered.push(elem);
              }
            });
            // gruppoElettrogeno 49
            items.forEach((elem: any) => {
              if (elem.structureObjectType === "gruppoElettrogeno") {
                itemsOrdered.push(elem);
              }
            });
            // attivitavvf 50
            items.forEach((elem: any) => {
              if (elem.structureObjectType === "attivitavvf") {
                itemsOrdered.push(elem);
              }
            });
            // varie
            items.forEach((elem: any) => {
              if (elem.structureObjectType === "-1") {
                itemsOrdered.push(elem);
              }
            });
            contents.push({
              title: this.translateService.instant("properties.documents.vvFdefinitivo"),
              keyTranslateTitle: "properties.documents.vvFdefinitivo",
              type: "title",
              content: itemsOrdered
            });

            this.allDocs.push({
              keyTranslateTitle: "properties.documents.attivitaSottopostePrevenzioneIncendi",
              title: this.translateService.instant("properties.documents.attivitaSottopostePrevenzioneIncendi"),
              type: "title",
              content: contents
            })
          }

          //
          // ANTINCENDIO
          //
          if ((typeof res.data.sicurezzaAntincendioFacciate !== 'undefined'
            || res.data.incendioEstintori.length
            || res.data.incendioReteIdranti.length
            || res.data.incendioReteSprinkler.length
            || res.data.incendioStazionePompaggio.length
            || res.data.incendioRilevazione.length
            || res.data.incendioVentilazione.length
            || typeof res.data.incendioEvac !== 'undefined')
            && this.currentRole.propertiesPermission.antincendio) {
            const contents = [];
            if (typeof res.data.sicurezzaAntincendioFacciate !== 'undefined') {
              const items = this.getDocsFromSection(res.data.sicurezzaAntincendioFacciate);
              contents.push({
                title: this.translateService.instant("properties.documents.sicurezzaAntincendioFacciate"),
                keyTranslateTitle: "properties.documents.sicurezzaAntincendioFacciate",
                type: "doc",
                content: items
              });
            }
            if (res.data.incendioEstintori.length) {
              const items = res.data.incendioEstintori.map((elem: any) => {
                const structureName = this.condoStructure.estintori
                  ? this.condoStructure.estintori.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                return {
                  title: (structureName) ? structureName.nome : "",
                  active: (structureName) ? structureName.active : false,
                  type: "title",
                  docId: elem._id,
                  structureId: elem.structureObjectId,
                  content: this.getDocsFromSection(elem),
                };
              });
              contents.push({
                title: this.translateService.instant("properties.documents.incendioEstintori"),
                keyTranslateTitle: "properties.documents.incendioEstintori",
                type: "title",
                content: items
              });
            }
            if (res.data.incendioReteIdranti.length) {
              const items = res.data.incendioReteIdranti.map((elem: any) => {
                const structureName = this.condoStructure.reteIdranti
                  ? this.condoStructure.reteIdranti.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                return {
                  title: (structureName) ? structureName.nome : "",
                  active: (structureName) ? structureName.active : false,
                  type: "title",
                  docId: elem._id,
                  structureId: elem.structureObjectId,
                  content: this.getDocsFromSection(elem),
                };
              });
              contents.push({
                title: this.translateService.instant("properties.documents.incendioReteIdranti"),
                keyTranslateTitle: "properties.documents.incendioReteIdranti",
                type: "title",
                content: items
              });
            }
            if (res.data.incendioReteSprinkler.length) {
              const items = res.data.incendioReteSprinkler.map((elem: any) => {
                const structureName = this.condoStructure.reteSprinkler
                  ? this.condoStructure.reteSprinkler.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                return {
                  title: (structureName) ? structureName.nome : "",
                  active: (structureName) ? structureName.active : false,
                  type: "title",
                  docId: elem._id,
                  structureId: elem.structureObjectId,
                  content: this.getDocsFromSection(elem),
                };
              });
              contents.push({
                title: this.translateService.instant("properties.documents.incendioReteSprinkler"),
                keyTranslateTitle: "properties.documents.incendioReteSprinkler",
                type: "title",
                content: items
              });
            }
            if (res.data.incendioStazionePompaggio.length) {
              const items = res.data.incendioStazionePompaggio.map((elem: any) => {
                const structureName = this.condoStructure.stazionePompaggio
                  ? this.condoStructure.stazionePompaggio.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                return {
                  title: (structureName) ? structureName.nome : "",
                  active: (structureName) ? structureName.active : false,
                  type: "title",
                  docId: elem._id,
                  structureId: elem.structureObjectId,
                  content: this.getDocsFromSection(elem),
                };
              });
              contents.push({
                title: this.translateService.instant("properties.documents.incendioStazionePompaggio"),
                keyTranslateTitle: "properties.documents.incendioStazionePompaggio",
                type: "title",
                content: items
              });
            }
            if (res.data.incendioRilevazione.length) {
              const items = res.data.incendioRilevazione.map((elem: any) => {
                const structureName = this.condoStructure.rilevazioneFumi
                  ? this.condoStructure.rilevazioneFumi.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                return {
                  title: (structureName) ? structureName.nome : "",
                  active: (structureName) ? structureName.active : false,
                  type: "title",
                  docId: elem._id,
                  structureId: elem.structureObjectId,
                  content: this.getDocsFromSection(elem),
                };
              });
              contents.push({
                title: this.translateService.instant("properties.documents.incendioRilevazione"),
                keyTranslateTitle: "properties.documents.incendioRilevazione",
                type: "title",
                content: items
              });
            }
            if (res.data.incendioVentilazione.length) {
              const items = res.data.incendioVentilazione.map((elem: any) => {
                const structureName = this.condoStructure.ventilazione
                  ? this.condoStructure.ventilazione.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                return {
                  title: (structureName) ? structureName.nome : "",
                  active: (structureName) ? structureName.active : false,
                  type: "title",
                  docId: elem._id,
                  structureId: elem.structureObjectId,
                  content: this.getDocsFromSection(elem),
                };
              });
              contents.push({
                title: this.translateService.instant("properties.documents.incendioVentilazione"),
                keyTranslateTitle: "properties.documents.incendioVentilazione",
                type: "title",
                content: items
              });
            }
            if (typeof res.data.incendioEvac !== 'undefined') {
              const items = this.getDocsFromSection(res.data.incendioEvac);
              contents.push({
                title: this.translateService.instant("properties.documents.incendioEvac"),
                keyTranslateTitle: "properties.documents.incendioEvac",
                type: "doc",
                content: items
              });
            }

            this.allDocs.push({
              keyTranslateTitle: "properties.documents.impiantiAntincendio",
              title: this.translateService.instant("properties.documents.impiantiAntincendio"),
              type: "title",
              content: contents
            })
          }

          //
          // IMPIANTI SPECIALI
          //
          if (res.data.impiantiSpeciali.length
            && this.currentRole.propertiesPermission.impiantiSpeciali) {
            const contents = [];
            if (res.data.impiantiSpeciali.length) {
              const items = res.data.impiantiSpeciali.map((elem: any) => {
                const structureName = this.condoStructure.impiantoSpeciale
                  ? this.condoStructure.impiantoSpeciale.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                return {
                  title: (structureName) ? structureName.nome : "",
                  active: (structureName) ? structureName.active : false,
                  type: "title",
                  docId: elem._id,
                  structureId: elem.structureObjectId,
                  content: this.getDocsFromSection(elem),
                };
              });
              contents.push({
                title: this.translateService.instant("properties.documents.impiantiSpeciali"),
                keyTranslateTitle: "properties.documents.impiantiSpeciali",
                type: "title",
                content: items
              });
            }

            this.allDocs.push({
              keyTranslateTitle: "properties.documents.impiantiSpeciali",
              title: this.translateService.instant("properties.documents.impiantiSpeciali"),
              type: "title",
              content: contents
            })
          }

          //
          // IMPIANTI RICREATIVI/SPORTIVI
          //
          if ((res.data.impricreativipiscina.length
            || res.data.impricreativipalestra.length
            || res.data.impricreativicampoTennis.length
            || res.data.impricreativicampoCalcio.length
            || res.data.impricreativiparcoGiochi.length)
            && this.currentRole.propertiesPermission.impiantiRicreativiSportivi) {
            const contents = [];
            if (res.data.impricreativipiscina.length) {
              const items = res.data.impricreativipiscina.map((elem: any) => {
                const structureName = this.condoStructure.piscina
                  ? this.condoStructure.piscina.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                return {
                  title: (structureName) ? structureName.nome : "",
                  active: (structureName) ? structureName.active : false,
                  type: "title",
                  docId: elem._id,
                  structureId: elem.structureObjectId,
                  content: this.getDocsFromSection(elem),
                };
              });
              contents.push({
                title: this.translateService.instant("properties.documents.impricreativipiscina"),
                keyTranslateTitle: "properties.documents.impricreativipiscina",
                type: "title",
                content: items
              });
            }
            if (res.data.impricreativipalestra.length) {
              const items = res.data.impricreativipalestra.map((elem: any) => {
                const structureName = this.condoStructure.palestra
                  ? this.condoStructure.palestra.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                return {
                  title: (structureName) ? structureName.nome : "",
                  active: (structureName) ? structureName.active : false,
                  type: "title",
                  docId: elem._id,
                  structureId: elem.structureObjectId,
                  content: this.getDocsFromSection(elem),
                };
              });
              contents.push({
                title: this.translateService.instant("properties.documents.impricreativipalestra"),
                keyTranslateTitle: "properties.documents.impricreativipalestra",
                type: "title",
                content: items
              });
            }
            if (res.data.impricreativicampoTennis.length) {
              const items = res.data.impricreativicampoTennis.map((elem: any) => {
                const structureName = this.condoStructure.campoTennis
                  ? this.condoStructure.campoTennis.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                return {
                  title: (structureName) ? structureName.nome : "",
                  active: (structureName) ? structureName.active : false,
                  type: "title",
                  docId: elem._id,
                  structureId: elem.structureObjectId,
                  content: this.getDocsFromSection(elem),
                };
              });
              contents.push({
                title: this.translateService.instant("properties.documents.impricreativicampoTennis"),
                keyTranslateTitle: "properties.documents.impricreativicampoTennis",
                type: "title",
                content: items
              });
            }
            if (res.data.impricreativicampoCalcio.length) {
              const items = res.data.impricreativicampoCalcio.map((elem: any) => {
                const structureName = this.condoStructure.campoCalcio
                  ? this.condoStructure.campoCalcio.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                return {
                  title: (structureName) ? structureName.nome : "",
                  active: (structureName) ? structureName.active : false,
                  type: "title",
                  docId: elem._id,
                  structureId: elem.structureObjectId,
                  content: this.getDocsFromSection(elem),
                };
              });
              contents.push({
                title: this.translateService.instant("properties.documents.impricreativicampoCalcio"),
                keyTranslateTitle: "properties.documents.impricreativicampoCalcio",
                type: "title",
                content: items
              });
            }
            if (res.data.impricreativiparcoGiochi.length) {
              const items = res.data.impricreativiparcoGiochi.map((elem: any) => {
                const structureName = this.condoStructure.parcoGiochi
                  ? this.condoStructure.parcoGiochi.find((item: any) => {
                    return item._id === elem.structureObjectId;
                  })
                  : undefined;
                return {
                  title: (structureName) ? structureName.nome : "",
                  active: (structureName) ? structureName.active : false,
                  type: "title",
                  docId: elem._id,
                  structureId: elem.structureObjectId,
                  content: this.getDocsFromSection(elem),
                };
              });
              contents.push({
                title: this.translateService.instant("properties.documents.impricreativiparcoGiochi"),
                keyTranslateTitle: "properties.documents.impricreativiparcoGiochi",
                type: "title",
                content: items
              });
            }

            this.allDocs.push({
              keyTranslateTitle: "properties.documents.impiantiRicreativiSportivi",
              title: this.translateService.instant("properties.documents.impiantiRicreativiSportivi"),
              type: "title",
              content: contents
            })
          }

          //
          // UNITA' IMMOBILIARI
          // I documenti sono raggruppati per unità immobiliare
          if (this.condoStructure.unitaAbitativaCommerciale
            && Array.isArray(this.condoStructure.unitaAbitativaCommerciale)
            && this.condoStructure.unitaAbitativaCommerciale.length
            && this.currentRole.propertiesPermission.unitaImmobiliari) {
            const unitaImmobiliari = [];
            
            this.condoStructure.unitaAbitativaCommerciale.forEach((el: any) => {
              const contents = [];
              if (res.data.unitaimmvvf.length) {
                const index = res.data.unitaimmvvf.findIndex((item: any) => {
                  return el._id === item.structureObjectId;
                });
                if (index > -1) {
                  const elem = res.data.unitaimmvvf[index];
                  contents.push({
                    title: this.translateService.instant("properties.documents.unitaimmvvf"),
                    active: true,
                    keyTranslateTitle: "properties.documents.unitaimmvvf",
                    type: "title",
                    docId: elem._id,
                    structureId: elem.structureObjectId,
                    content: this.getDocsFromSection(elem),
                  })
                }
              }
              if (res.data.unitaImmdocAmm.length) {
                const index = res.data.unitaImmdocAmm.findIndex((item: any) => {
                  return el._id === item.structureObjectId;
                });
                if (index > -1) {
                  const elem = res.data.unitaImmdocAmm[index];
                  contents.push({
                    title: this.translateService.instant("properties.documents.unitaImmdocAmm"),
                    active: true,
                    keyTranslateTitle: "properties.documents.unitaImmdocAmm",
                    type: "title",
                    docId: elem._id,
                    structureId: elem.structureObjectId,
                    content: this.getDocsFromSection(elem),
                  })
                }
              }
              if (res.data.unitaimmelettrico.length) {
                const index = res.data.unitaimmelettrico.findIndex((item: any) => {
                  return el._id === item.structureObjectId;
                });
                if (index > -1) {
                  const elem = res.data.unitaimmelettrico[index];
                  contents.push({
                    title: this.translateService.instant("properties.documents.unitaimmelettrico"),
                    active: true,
                    keyTranslateTitle: "properties.documents.unitaimmelettrico",
                    type: "title",
                    docId: elem._id,
                    structureId: elem.structureObjectId,
                    content: this.getDocsFromSection(elem),
                  })
                }
              }
              if (res.data.unitaimmantintrusione.length) {
                const index = res.data.unitaimmantintrusione.findIndex((item: any) => {
                  return el._id === item.structureObjectId;
                });
                if (index > -1) {
                  const elem = res.data.unitaimmantintrusione[index];
                  contents.push({
                    title: this.translateService.instant("properties.documents.unitaimmantintrusione"),
                    active: true,
                    keyTranslateTitle: "properties.documents.unitaimmantintrusione",
                    type: "title",
                    docId: elem._id,
                    structureId: elem.structureObjectId,
                    content: this.getDocsFromSection(elem),
                  })
                }
              }
              if (res.data.unitaimmidricoSanitari.length) {
                const index = res.data.unitaimmidricoSanitari.findIndex((item: any) => {
                  return el._id === item.structureObjectId;
                });
                if (index > -1) {
                  const elem = res.data.unitaimmidricoSanitari[index];
                  contents.push({
                    title: this.translateService.instant("properties.documents.unitaimmidricoSanitari"),
                    active: true,
                    keyTranslateTitle: "properties.documents.unitaimmidricoSanitari",
                    type: "title",
                    docId: elem._id,
                    structureId: elem.structureObjectId,
                    content: this.getDocsFromSection(elem),
                  })
                }
              }
              if (res.data.unitaimmtermico.length) {
                const index = res.data.unitaimmtermico.findIndex((item: any) => {
                  return el._id === item.structureObjectId;
                });
                if (index > -1) {
                  const elem = res.data.unitaimmtermico[index];
                  contents.push({
                    title: this.translateService.instant("properties.documents.unitaimmtermico"),
                    active: true,
                    keyTranslateTitle: "properties.documents.unitaimmtermico",
                    type: "title",
                    docId: elem._id,
                    structureId: elem.structureObjectId,
                    content: this.getDocsFromSection(elem),
                  })
                }
              }
              if (res.data.unitaimmcondizionamento.length) {
                const index = res.data.unitaimmcondizionamento.findIndex((item: any) => {
                  return el._id === item.structureObjectId;
                });
                if (index > -1) {
                  const elem = res.data.unitaimmcondizionamento[index];
                  contents.push({
                    title: this.translateService.instant("properties.documents.unitaimmcondizionamento"),
                    active: true,
                    keyTranslateTitle: "properties.documents.unitaimmcondizionamento",
                    type: "title",
                    docId: elem._id,
                    structureId: elem.structureObjectId,
                    content: this.getDocsFromSection(elem),
                  })
                }
              }
              if (res.data.unitaimmape.length) {
                const index = res.data.unitaimmape.findIndex((item: any) => {
                  return el._id === item.structureObjectId;
                });
                if (index > -1) {
                  const elem = res.data.unitaimmape[index];
                  contents.push({
                    title: this.translateService.instant("properties.documents.unitaimmape"),
                    active: true,
                    keyTranslateTitle: "properties.documents.unitaimmape",
                    type: "title",
                    docId: elem._id,
                    structureId: elem.structureObjectId,
                    content: this.getDocsFromSection(elem),
                  })
                }
              }
              if (res.data.unitaimmelaboratiGrafici.length) {
                const index = res.data.unitaimmelaboratiGrafici.findIndex((item: any) => {
                  return el._id === item.structureObjectId;
                });
                if (index > -1) {
                  const elem = res.data.unitaimmelaboratiGrafici[index];
                  contents.push({
                    title: this.translateService.instant("properties.documents.unitaimmelaboratiGrafici"),
                    active: true,
                    keyTranslateTitle: "properties.documents.unitaimmelaboratiGrafici",
                    type: "title",
                    docId: elem._id,
                    structureId: elem.structureObjectId,
                    content: this.getDocsFromSection(elem),
                  })
                }
              }
              if (res.data.unitaimmcanneFumariePer.length) {
                const index = res.data.unitaimmcanneFumariePer.findIndex((item: any) => {
                  return el._id === item.structureObjectId;
                });
                if (index > -1) {
                  const elem = res.data.unitaimmcanneFumariePer[index];
                  contents.push({
                    title: this.translateService.instant("properties.documents.unitaimmcanneFumariePer"),
                    active: true,
                    keyTranslateTitle: "properties.documents.unitaimmcanneFumariePer",
                    type: "title",
                    docId: elem._id,
                    structureId: elem.structureObjectId,
                    content: this.getDocsFromSection(elem),
                  })
                }
              }
              if (res.data.unitaImmsicurezza.length) {
                const index = res.data.unitaImmsicurezza.findIndex((item: any) => {
                  return el._id === item.structureObjectId;
                });
                if (index > -1) {
                  const elem = res.data.unitaImmsicurezza[index];
                  contents.push({
                    title: this.translateService.instant("properties.documents.unitaImmsicurezza"),
                    active: true,
                    keyTranslateTitle: "properties.documents.unitaImmsicurezza",
                    type: "title",
                    docId: elem._id,
                    structureId: elem.structureObjectId,
                    content: this.getDocsFromSection(elem),
                  })
                }
              }

              unitaImmobiliari.push({
                title: el.nome,
                type: "title",
                content: contents
              });
            });

            this.allDocs.push({
              keyTranslateTitle: "properties.documents.unitaImmobiliari",
              title: this.translateService.instant("properties.documents.unitaImmobiliari"),
              type: "title",
              content: unitaImmobiliari
            })
          }


          //this.displayedDocs = this.allDocs;
          this.countDocPerArea();
          if (this.allDocs && Array.isArray(this.allDocs) && this.allDocs.length) {
            this.displayedDocs = this.filterDisplayedDocs(this.allDocs);
          }
        } else {
          this.toastrService.error(res.message);
        }

        this.documentArchiveIsLoading = false;
      });
  }
  getDocumentArchiveData2(): void {
    this.documentArchiveIsLoading = true;
    this.insertedDocs = [];
    this.documentArchivesService
      .get(this.property.get("documentArchive"))
      .subscribe((res) => {
        if (res.status) {
          this.documentArchive = res.data;
          if (this.documentArchive.suppliersName) {
            this.suppliersName = this.documentArchive.suppliersName;
          }
          if (this.documentArchive.yearsOfStorage) {
            this.yearsOfStorage = this.documentArchive.yearsOfStorage;
          }
          if (this.documentArchive.conductorName) {
            this.conductorName = this.documentArchive.conductorName;
          }
          if (this.documentArchive.nameInterventionArchiving) {
            this.nameInterventionArchiving =
              this.documentArchive.nameInterventionArchiving;
          }
   
          this.allDocs = this.documentTypeStructure.getDocumentArchiveData(
            this.lang, 
            this.documentTemplate, 
            this.condoStructure, 
            this.documentArchive,
            this.subscriptionType,
            this.insertedDocs,
          );

          this.countDocPerArea();
          if (this.allDocs && Array.isArray(this.allDocs) && this.allDocs.length) {
            this.displayedDocs = this.filterDisplayedDocs(this.allDocs);
          }
        } else {
          this.toastrService.error(res.message);
        }

        this.documentArchiveIsLoading = false;
      });
  }

  /**
   * Utility: extracts documents from one section of documentArchive
   * and show the documents into page
   * in getDocumentArchiveData()
   *
   * array of documents
   *
   * @since 1.0.0
   */
  getDocsFromSection(section): any {
    const docList = [];
    for (const doc in section.documents) {
      if (section.documents[doc].length) {
        section.documents[doc].forEach((item: any) => {
          if (!item.deleted && !item.expired) {
            if (item.data && 
              item.data.nomeSocietaEroganteInServizio &&
              // && (item.data.rilasciatoFirmatoDa
              //   || item.data.nomeDiRiferimento
              //   || item.data.nomeSocietaEroganteInServizio)
              typeof item.data.ragioneSocialeFornitore === "undefined") {
              if (item.data.rilasciatoFirmatoDa) {
                item.data["ragioneSocialeFornitore"] = item.data.rilasciatoFirmatoDa;
              } else if (item.data.nomeDiRiferimento) {
                item.data["ragioneSocialeFornitore"] = item.data.nomeDiRiferimento;
              } else {
                item.data["ragioneSocialeFornitore"] = item.data.nomeSocietaEroganteInServizio;
              }
            }
            docList.push({
              title: this.translateService.instant("properties.documents.titles." + doc),
              type: "doc",
              docId: item._id,
              key: doc,
              mandatory: item.mandatory,
              expired: item.expired,
              deleted: item.deleted,
              dateExpired: item.dateExpired,
              data: item.data,
            });
          }
          if (!item.deleted && item.data) {
            this.insertedDocs.push({
              title: this.translateService.instant("properties.documents.titles." + doc),
              docId: item._id,
              data: item.data,
            })
          }
        });
      }
    }
    return docList;
  }

  /**
   * Utility: extracts only contracts from one section of documentArchive
   * and show the documents into page
   * in getDocumentArchiveData()
   *
   * array of documents
   *
   * @since 1.0.0
   */
  getDocsFromContractSection(section, keyTranslateTitle): any {
    const docList = [];
    for (const doc in section.documents) {
      if (section.documents[doc].length) {
        section.documents[doc].forEach((item: any) => {
          if (item.contract) {
            if (!item.deleted && !item.expired) {
              if (item.data &&
                item.data.nomeSocietaEroganteInServizio &&
                // && (item.data.rilasciatoFirmatoDa
                //   || item.data.nomeDiRiferimento
                //   || item.data.nomeSocietaEroganteInServizio)
                typeof item.data.ragioneSocialeFornitore === "undefined") {
                if (item.data.rilasciatoFirmatoDa) {
                  item.data["ragioneSocialeFornitore"] = item.data.rilasciatoFirmatoDa;
                } else if (item.data.nomeDiRiferimento) {
                  item.data["ragioneSocialeFornitore"] = item.data.nomeDiRiferimento;
                } else {
                  item.data["ragioneSocialeFornitore"] = item.data.nomeSocietaEroganteInServizio;
                }
              }
              docList.push({
                title: this.translateService.instant("properties.documents.titles." + doc),
                type: "doc",
                docId: item._id,
                key: doc,
                mandatory: item.mandatory,
                expired: item.expired,
                deleted: item.deleted,
                dateExpired: item.dateExpired,
                contract: item.contract,
                pdfmsg: item.pdfmsg,
                data: item.data,
                checked: false,
                keyTranslateTitle,
              });
            }
            // only contracts
            const contractSection = doc.substr(0, 2) === "HA" ? true : false;
            if (!item.deleted && item.data && contractSection) {
              this.insertedDocs.push({
                title: this.translateService.instant("properties.documents.titles." + doc),
                docId: item._id,
                data: item.data,
                checked: false,
                keyTranslateTitle,
              })
            }
          }
        });
      }
    }

    docList.sort(this.compareExpired);
    return docList;
  }

  /**
   * Order docs by expired property
   *
   * @since 1.0.0
   */
  compareExpired(a, b): any {
    if (a.expired < b.expired) {
      return -1;
    } else if (a.expired > b.expired) {
      return 1;
    } else {
      return 0;
    }
  }

  /**
   * Count document per area and make visible the area in side menu.
   * Count mandatory, mandatory not inserted and generic document.
   * Show the counters into badge of side menu.
   * method used into getDocumentArchiveData()
   *
   * @since 1.0.0
   */
  countDocPerArea(): void {
    this.totMandatoryDocs = 0;
    this.totInsertDocs = 0;
    this.totNotInsertDocs = 0
    this.totOptionalDocs = 0;
    this.totDocs = 0;
    // Hide all visible elements of side menu
    for (const key in this.documentsStructure) {
      this.documentsStructure[key].visible = false;
      if (Array.isArray(this.documentsStructure[key].content)) {
        this.documentsStructure[key].content.forEach((el: any) => {
          el.visible = false;
        });
      }
    }

    if (this.allDocs && Array.isArray(this.allDocs)) {
      this.allDocs.forEach((item: any) => {
        const title = item.keyTranslateTitle;
        const levels = item.content;
        if (
          title !== "properties.documents.unitaImmobiliari" && 
          title !== "properties.documents.attivitaSottopostePrevenzioneIncendi" &&
          this.filterMenuItem(title)
        ) {
          for (const key in this.documentsStructure) {
            if (this.documentsStructure[key].title === title) {
              this.documentsStructure[key].visible = true;

              levels.forEach((el: any) => {
                this.documentsStructure[key].content.forEach((subEl: any) => {
                  if (subEl.title === el.keyTranslateTitle) {
                    subEl.visible = true;
                    subEl.notInsert = 0;
                    subEl.mandatory = 0;
                    subEl.optional = 0;
                    let inserted = 0;
                    if (Array.isArray(el.content)) {
                      el.content.forEach((subSubEl: any) => {
                        if (Array.isArray(subSubEl.content)) {
                          subSubEl.content.forEach((subSubSubEl: any) => {
                            if (subSubSubEl.mandatory) {
                              this.totMandatoryDocs++;
                              if (this.helperService.isDocumentDataPopulated(subSubSubEl.data)) {
                                subEl.mandatory++;
                                this.totInsertDocs++;
                              }
                            }
                            if (subSubSubEl.mandatory && !this.helperService.isDocumentDataPopulated(subSubSubEl.data)) {
                              subEl.notInsert++;
                              this.totNotInsertDocs++;
                            }
                            if (!subSubSubEl.mandatory) {
                              subEl.optional++;
                              this.totOptionalDocs++;
                            }
                            if ( 
                              this.helperService.isDocumentDataPopulated(subSubSubEl.data)
                            ) {
                              inserted += 1;
                            }
                          })
                        } else {
                          if (subSubEl.mandatory) {
                            this.totMandatoryDocs++;
                            if (this.helperService.isDocumentDataPopulated(subSubEl.data)) {
                              subEl.mandatory++;
                              this.totInsertDocs++;
                            }
                          }
                          if (subSubEl.mandatory && !this.helperService.isDocumentDataPopulated(subSubEl.data)) {
                            subEl.notInsert++;
                            this.totNotInsertDocs++;
                          }
                          if (!subSubEl.mandatory) {
                            subEl.optional++;
                            this.totOptionalDocs++;
                          }
                          if ( 
                            this.helperService.isDocumentDataPopulated(subSubEl.data)
                          ) {
                            inserted += 1;
                          }
                        }
                      })
                    }
                    if (
                      (
                        inserted === 0 && 
                        this.currentRole.propertiesPermission.docsInserted
                      ) ||
                      (
                        inserted === 0 && 
                        subEl.notInsert === 0 && 
                        !this.currentRole.propertiesPermission.docsInserted
                      )
                    ) {
                      subEl.visible = false;
                    }
                  }
                });
              });
              break;
            }
          }
        } else if (
          title === "properties.documents.unitaImmobiliari" &&
          this.filterMenuItem(title)
        ) {
          for (const key in this.documentsStructure) {
            if (this.documentsStructure[key].title === title) {
              this.documentsStructure[key].content.length = 0;
              this.documentsStructure[key].visible = true;
              levels.forEach((el: any) => {

                const subEl: DocumentInterface = {
                  title: el.title,
                  type: "link",
                  section: "string",
                  key: "",
                  visible: true,
                  notInsert: 0,
                  mandatory: 0,
                  optional: 0,
                };
                let inserted = 0;
                if (Array.isArray(el.content)) {
                  el.content.forEach((subSubEl: any) => {
                    if (Array.isArray(subSubEl.content)) {
                      subSubEl.content.forEach((subSubSubEl: any) => {
                        if (subSubSubEl.mandatory) {
                          this.totMandatoryDocs++;
                          if (this.helperService.isDocumentDataPopulated(subSubSubEl.data)) {
                            subEl.mandatory++;
                            this.totInsertDocs++;
                          }
                        }
                        if (subSubSubEl.mandatory && !this.helperService.isDocumentDataPopulated(subSubSubEl.data)) {
                          subEl.notInsert++;
                          this.totNotInsertDocs++;
                        }
                        if (!subSubSubEl.mandatory) {
                          subEl.optional++;
                          this.totOptionalDocs++;
                        }
                        if ( 
                          this.helperService.isDocumentDataPopulated(subSubSubEl.data)
                        ) {
                          inserted += 1;
                        }
                      })
                    } else {
                      if (subSubEl.mandatory) {
                        this.totMandatoryDocs++;
                        if (this.helperService.isDocumentDataPopulated(subSubEl.data)) {
                          subEl.mandatory++;
                          this.totInsertDocs++;
                        }
                      }
                      if (subSubEl.mandatory && !this.helperService.isDocumentDataPopulated(subSubEl.data)) {
                        subEl.notInsert++;
                        this.totNotInsertDocs++;
                      }
                      if (!subSubEl.mandatory) {
                        subEl.optional++;
                        this.totOptionalDocs++;
                      }
                      if ( 
                        this.helperService.isDocumentDataPopulated(subSubEl.data)
                      ) {
                        inserted += 1;
                      }
                    }
                  })
                }

                if (
                  (
                    inserted === 0 && 
                    this.currentRole.propertiesPermission.docsInserted
                  ) ||
                  (
                    inserted === 0 && 
                    subEl.notInsert === 0 && 
                    !this.currentRole.propertiesPermission.docsInserted
                  )
                ) {
                  subEl.visible = false;
                }

                this.documentsStructure[key].content.push(subEl);

              });
              break;
            }
          }
        } else if (
          title === "properties.documents.attivitaSottopostePrevenzioneIncendi" &&
          this.filterMenuItem(title)
        ) {
          for (const key in this.documentsStructure) {
            if (this.documentsStructure[key].title === title) {
              this.documentsStructure[key].content.length = 0;
              this.documentsStructure[key].visible = true;
              if (Array.isArray(levels[0].content)) {
                levels[0].content.forEach((el: any) => {
                  const subEl: DocumentInterface = {
                    title: el.title,
                    type: "link",
                    section: "string",
                    key: "",
                    visible: true,
                    notInsert: 0,
                    mandatory: 0,
                    optional: 0,
                  };
                  let inserted = 0;
                  if (Array.isArray(el.content)) {
                    el.content.forEach((subSubEl: any) => {
                      if (Array.isArray(subSubEl.content)) {
                        subSubEl.content.forEach((subSubSubEl: any) => {
                          if (subSubSubEl.mandatory) {
                            this.totMandatoryDocs++;
                            if (this.helperService.isDocumentDataPopulated(subSubSubEl.data)) {
                              subEl.mandatory++;
                              this.totInsertDocs++;
                            }
                          }
                          if (subSubSubEl.mandatory && !this.helperService.isDocumentDataPopulated(subSubSubEl.data)) {
                            subEl.notInsert++;
                            this.totNotInsertDocs++;
                          }
                          if (!subSubSubEl.mandatory) {
                            subEl.optional++;
                            this.totOptionalDocs++;
                          }
                          if ( 
                            this.helperService.isDocumentDataPopulated(subSubSubEl.data)
                          ) {
                            inserted += 1;
                          }
                        })
                      } else {
                        if (subSubEl.mandatory) {
                          this.totMandatoryDocs++;
                          if (this.helperService.isDocumentDataPopulated(subSubEl.data)) {
                            subEl.mandatory++;
                            this.totInsertDocs++;
                          }
                        }
                        if (subSubEl.mandatory && !this.helperService.isDocumentDataPopulated(subSubEl.data)) {
                          subEl.notInsert++;
                          this.totNotInsertDocs++;
                        }
                        if (!subSubEl.mandatory) {
                          subEl.optional++;
                          this.totOptionalDocs++;
                        }
                        if ( 
                          this.helperService.isDocumentDataPopulated(subSubEl.data)
                        ) {
                          inserted += 1;
                        }
                      }
                    })
                  }

                  if (
                    (
                      inserted === 0 && 
                      this.currentRole.propertiesPermission.docsInserted
                    ) ||
                    (
                      inserted === 0 && 
                      subEl.notInsert === 0 && 
                      !this.currentRole.propertiesPermission.docsInserted
                    )
                  ) {
                    subEl.visible = false;
                  }

                  this.documentsStructure[key].content.push(subEl);

                });
              }
              break;
            }
          }
        }
      });
    }
    this.documentsStructure.forEach((el: any) => {
      if (el.visible) {
        if (
          el.content &&
          Array.isArray(el.content) &&
          el.content.length
        ) {
          el.visible = el.content.some((subEl: any) => 
            subEl.visible
          );
        } else {
          el.visible = false;
        }
      }
    });

    // this.progressBarVal = 0;
    // if ((this.totInsertDocs + this.totNotInsertDocs) > 0) {
    //   this.progressBarVal = Math.trunc((this.totInsertDocs / (this.totInsertDocs + this.totNotInsertDocs)) * 100);
    // }

    // this.progressBarValStyle = { 'width': `${this.progressBarVal}%` };

    this.totDocs = this.totOptionalDocs + this.totInsertDocs;
  }

  filterMenuItem(title: string): boolean {
    if (
      (title === "properties.documents.gestionaleAmministrativo" && 
      !this.currentRole.propertiesPermission.gestionaleAmministrativo)
      ||
      (title === "properties.documents.verbaliconvocazioni" && 
      !this.currentRole.propertiesPermission.gestionaleContabile)
      ||
      (title === "properties.documents.urbanisticaEdEdilizia" && 
      !this.currentRole.propertiesPermission.urbanisticaEdEdilizia)
      ||
      (title === "properties.documents.catasto" && 
      !this.currentRole.propertiesPermission.catasto)
      ||
      (title === "properties.documents.contratti" && 
      !this.currentRole.propertiesPermission.contratti)
      ||
      (title === "properties.documents.lineaVita" && 
      !this.currentRole.propertiesPermission.lineaVita)
      ||
      (title === "properties.documents.amiantoDoc" && 
      !this.currentRole.propertiesPermission.amiantoDoc)
      ||
      (title === "properties.documents.edile" && 
      !this.currentRole.propertiesPermission.edile)
      ||
      (title === "properties.documents.impiantoElettrico" && 
      !this.currentRole.propertiesPermission.impiantoElettrico)
      ||
      (title === "properties.documents.riscaldamentoCondizionamento" && 
      !this.currentRole.propertiesPermission.riscaldamentoCondizionamento)
      ||
      (title === "properties.documents.ascensoriEMontauto" && 
      !this.currentRole.propertiesPermission.ascensori)
      ||
      (title === "properties.documents.trattamentoAcqua" && 
      !this.currentRole.propertiesPermission.trattamentoAcqua)
      ||
      (title === "properties.documents.impiantiElettronici" && 
      !this.currentRole.propertiesPermission.impiantiElettronici)
      ||
      (
        (title === "properties.documents.impiantiAntincendio" || 
        title === "properties.documents.attivitaSottopostePrevenzioneIncendi") && 
      !this.currentRole.propertiesPermission.antincendio)
      ||
      (title === "properties.documents.impiantiSpeciali" && 
      !this.currentRole.propertiesPermission.impiantiSpeciali)
      ||
      (title === "properties.documents.impiantiRicreativiSportivi" && 
      !this.currentRole.propertiesPermission.impiantiRicreativiSportivi)
      ||
      (title === "properties.documents.unitaImmobiliari" && 
      !this.currentRole.propertiesPermission.unitaImmobiliari)
    ) {
      return false;
    }
    return true;
  }

  filterDisplayedDocs(docs: any) {
    if (
      (docs.keyTranslateTitle === "properties.documents.gestionaleAmministrativo" && 
      !this.currentRole.propertiesPermission.gestionaleAmministrativo)
      ||
      (docs.keyTranslateTitle === "properties.documents.R5gestionali" && 
      !this.currentRole.propertiesPermission.gestionaleContabile)
      ||
      (docs.keyTranslateTitle === "properties.documents.urbanisticaEdEdilizia" && 
      !this.currentRole.propertiesPermission.urbanisticaEdEdilizia)
      ||
      (docs.keyTranslateTitle === "properties.documents.catasto" && 
      !this.currentRole.propertiesPermission.catasto)
      ||
      (docs.keyTranslateTitle === "properties.documents.contratti" && 
      !this.currentRole.propertiesPermission.contratti)
      ||
      (docs.keyTranslateTitle === "properties.documents.lineaVita" && 
      !this.currentRole.propertiesPermission.lineaVita)
      ||
      (docs.keyTranslateTitle === "properties.documents.amiantoDoc" && 
      !this.currentRole.propertiesPermission.amiantoDoc)
      ||
      (docs.keyTranslateTitle === "properties.documents.edile" && 
      !this.currentRole.propertiesPermission.edile)
      ||
      (docs.keyTranslateTitle === "properties.documents.impiantoElettrico" && 
      !this.currentRole.propertiesPermission.impiantoElettrico)
      ||
      (docs.keyTranslateTitle === "properties.documents.riscaldamentoCondizionamento" && 
      !this.currentRole.propertiesPermission.riscaldamentoCondizionamento)
      ||
      (docs.keyTranslateTitle === "properties.documents.ascensoriEMontauto" && 
      !this.currentRole.propertiesPermission.ascensori)
      ||
      (docs.keyTranslateTitle === "properties.documents.trattamentoAcqua" && 
      !this.currentRole.propertiesPermission.trattamentoAcqua)
      ||
      (docs.keyTranslateTitle === "properties.documents.impiantiElettronici" && 
      !this.currentRole.propertiesPermission.impiantiElettronici)
      ||
      (
        (docs.keyTranslateTitle === "properties.documents.impiantiAntincendio" || 
        docs.keyTranslateTitle === "properties.documents.attivitaSottopostePrevenzioneIncendi") && 
      !this.currentRole.propertiesPermission.antincendio)
      ||
      (docs.keyTranslateTitle === "properties.documents.impiantiSpeciali" && 
      !this.currentRole.propertiesPermission.impiantiSpeciali)
      ||
      (docs.keyTranslateTitle === "properties.documents.impiantiRicreativiSportivi" && 
      !this.currentRole.propertiesPermission.impiantiRicreativiSportivi)
      ||
      (docs.keyTranslateTitle === "properties.documents.unitaImmobiliari" && 
      !this.currentRole.propertiesPermission.unitaImmobiliari)
    ) {
      return "";
    }
    if (
      typeof docs.contract !== 'undefined' && 
      docs.contract &&
      !this.currentRole.propertiesPermission.contratti
    ) {
      return "";
    }
    // if (this.currentRole.propertiesPermission.gestionaleAmministrativo)
    if (docs.content && Array.isArray(docs.content) && docs.content.length) {
      let values = {};
      const contents = this.filterDisplayedDocs(docs.content);
      if (contents && Array.isArray(contents) && contents.length) {
        values = {
          content: contents,
          docId: docs.docId,
          structureId: docs.structureId,
          title: docs.title,
          type: docs.type
        };
      }
      return values;
    } else {
      if (docs && Array.isArray(docs) && docs.length) {
        const content = [];
        docs.forEach((docs: any) => {
          const ret = this.filterDisplayedDocs(docs);
          if (!(Object.keys(ret).length === 0 && ret.constructor === Object) && ret !== "") {
            content.push(ret);
          }
        });
        return content;
      } else {
        let found = false;
        if (typeof this.currentRole.propertiesPermission.docsInserted === "undefined" && docs.data) {  // only inserted docs
          found = true;
        }
        if (typeof this.currentRole.propertiesPermission.docsInserted !== "undefined"
          && this.currentRole.propertiesPermission.docsInserted
          && docs.data) {  // only inserted docs
          found = true;
        } else if (typeof this.currentRole.propertiesPermission.docsInserted !== "undefined"
          && !this.currentRole.propertiesPermission.docsInserted) { // all docs
          found = true;
        }
        if (found) {
          return docs;
        }
      }
    }
    return "";
  }

  /**
   * Handle click on document form to download file
   * itemData: data value of form items
   *
   * @since 1.0.0
   */
  onToggleDownloadDocument(
    documents: any,
  ): void {
    if (!documents || !documents.length) {
      console.warn("ERROR: NO DOCS");
      return;
    }
    const dialogRef = this.dialog.open(DocumentDownloadDialogComponent, {
      data: {
        propertyId: this.propertyId,
        documents,
      },
      width: "600px"
    });
    dialogRef.beforeClosed()
      .pipe(
        take(1)
      )
      .subscribe(
        res => {
          if (!res) {
            return;
          } else {
            this.documentArchiveIsLoading = true;
            // recreate view of all docs to show new inserted doc
            this.allDocs = [];
            this.getDocumentArchiveData2();
          }
        }
      );
  }

  /**
   * Translate all keys with given labels inside given object and returns it
   *
   * @since 4.0.0
   */
  translateKeys(keys: string[], obj: any): any {
    if (Array.isArray(obj)) {
      obj.forEach((item: MappingIndex) => {
        for (const prop in item) {
          if (item.hasOwnProperty(prop)) {
            if (keys.includes(prop)) {
              item[prop] = this.translateService.instant(item[prop]);
            }
            if (typeof item[prop] === "object") {
              item[prop] = this.translateKeys(keys, item[prop]);
            }
          }
        }
      });
    } else {
      for (const prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          if (keys.includes(prop) && obj[prop]) {
            obj[prop] = this.translateService.instant(obj[prop]);
          }
          if (typeof obj[prop] === "object") {
            obj[prop] = this.translateKeys(keys, obj[prop]);
          }
        }
      }
    }
    return obj;
  }
  translateKeys2(keys: string[], obj: any): any {
    if (Array.isArray(obj)) {
      obj.forEach((item: MappingIndex) => {
        for (const prop in item) {
          if (prop === "hooks") {
            const propKey = item[prop];
            item[prop] = {
              onInit(field: any) {
                field.defaultValue = `${propKey} ${+field.parent.key + 1}`;
              },
            };
          }
          if (prop === "hideExpression" && item[prop]) {
            const propKey = item[prop].key;
            const propCompareValue = item[prop].value;
            if (item[prop].operator === "!==") {
              item[prop] = (
                model: any,
                formState: any,
                field: FormlyFieldConfig
              ): boolean => {
                const key = propKey;
                const currentValue = model[key];
                const compareValue = propCompareValue;
                return currentValue !== compareValue;
              }
            } else if (item[prop].operator === "!") {
              item[prop] = (
                model: any,
                formState: any,
                field: FormlyFieldConfig
              ): boolean => {
                const key = propKey;
                const currentValue = model[key];
                return !currentValue;
              }
            } else if (item[prop].operator === "!includes") {
              item[prop] = (
                model: any,
                formState: any,
                field: FormlyFieldConfig
              ): boolean => {
                const key = propKey;
                const currentValue = model[key];
                const compareValue = propCompareValue;
                return typeof currentValue === "undefined" || !currentValue.includes(compareValue);
              }
            }
          }
          if (prop === "expressionProperties" && item[prop]) {
            let propDisabled = item[prop].disabled;
            if (
              propDisabled !== "formState.disabled" &&
              propDisabled !== "connessioni" &&
              propDisabled !== ""
            ) {
              const key = propDisabled;
              propDisabled = (model: any, formState: any, field: FormlyFieldConfig) => {
                return model[key];
              };
            } else if (propDisabled === "connessioni") {
              const key = propDisabled;
              propDisabled = (model: any, formState: any, field: FormlyFieldConfig) => {
                if (model[key] === "undefined") {
                  return false;
                } else if (Array.isArray(model[key]) && model[key].length > 0) {
                  return true;
                }
                return false;
              };
            }
            
            if (typeof item[prop].required !== "undefined") {
              const propKey = item[prop].required.key;
              const propCompareValue = item[prop].required.value;
              if (item[prop].required.operator === "===") {
                item[prop] = {
                  "templateOptions.disabled": propDisabled,
                  "templateOptions.required": (model: any, formState: any, field: FormlyFieldConfig) => {
                    const key = propKey;
                    const currentValue = model[key];
                    const compareValue = propCompareValue;
                    return currentValue === compareValue;
                  }
                }
              } else if (item[prop].required.operator === "!") {
                item[prop] = {
                  "templateOptions.disabled": propDisabled,
                  "templateOptions.required": (model: any, formState: any, field: FormlyFieldConfig) => {
                    const key = propKey;
                    const currentValue = model[key];
                    return !currentValue;
                  }
                }
              } else if (item[prop].required.operator === "") {
                item[prop] = {
                  "templateOptions.disabled": propDisabled,
                  "templateOptions.required": (model: any, formState: any, field: FormlyFieldConfig) => {
                    const key = propKey;
                    const currentValue = model[key];
                    return currentValue;
                  }
                }
              }
            } else {
              item[prop] = {
                "templateOptions.disabled": propDisabled,
              }
            }
          }
          if (prop === "defaultValue" && item[prop]) {
            if (item[prop] === "false") {
              item[prop] = false;
            } else if (item[prop] === "true") {
              item[prop] = true;
            }
          }
          if (prop === "wrappers" && item[prop] && Array.isArray(item[prop]) && item[prop].length === 0) {
            item[prop] = "";
          }
          if (item.hasOwnProperty(prop)) {
            if (keys.includes(prop)) {
              if (item["translation"]) {
                item[prop] = item["translation"].it;
              }
            }
            if (typeof item[prop] === "object") {
              item[prop] = this.translateKeys2(keys, item[prop]);
            }
          }
        }
      });
    } else {
      for (const prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          if (prop === "options" && Array.isArray(obj[prop])) {
            obj[prop].forEach((elem: any) => {
              if (elem.value && elem.value === "true") {
                elem.value = true;
              } else if (elem.value && elem.value === "false") {
                elem.value = false;
              }
            })
          }
          if (keys.includes(prop) && obj[prop]) {
            obj[prop] = this.translateService.instant(obj[prop]);
            if (prop === "label" && obj["translationLabel"]) {
              obj[prop] = obj["translationLabel"].it;
            } else if (prop === "placeholder" && obj["translationPlaceholder"]) {
              obj[prop] = obj["translationPlaceholder"].it;
            }
          }
          if (typeof obj[prop] === "object") {
            obj[prop] = this.translateKeys2(keys, obj[prop]);
          }
        }
      }
    }
    return obj;
  }

  /**
   * Check if given macr-section item is visibile or not depending on
   * structure open status. If structure is open, than this will always returns true
   * If it's false, this will check if at least one sub-section has one or more
   * values. If so, return true, otherwise return false;
   *
   * @since 1.0.0
   */
  checkVisibility(item: any): boolean {
    // // "Impianti speciali" and "Attività prev. incendi" are visible only Archedi users
    // if (
    //   (item.title === "properties.structures.attivitaPrevenzioneIncendi" ||
    //     item.title === "properties.structures.impiantiSpeciali") &&
    //   this.currentRole && (this.currentRole.type !== "admin" &&
    //     this.currentRole.type !== "operator")
    // ) {
    //   return false;
    // }
    const condoStructureClose = true;
    if (condoStructureClose) {
      if (item.content && item.content.length) {
        // Let's make anagrafica section ALWAYS visible
        if (item.content[0].key === "anagrafica") {
          return true;
        }
        return item.content.some(
          (subitem: MappingIndex) => this.getChildren(subitem.key).length
        );
      }
      return false;
    }
    return true;
  }

  /**
   * Navigate to given section inside the same property detail page
   *
   * @since 1.0.0
   */
  activateSection(rawSection: string): void {
    const top = document.getElementById("structure-card").offsetTop;
    window.scrollTo({
      top,
      behavior: "smooth"
    });

    // Reset data and call the new data form
    this.formActiveSubitemId = undefined;

    const controls = this.form.controls;
    for (const key in controls) {
      this.form.removeControl(key);
    }

    const section = rawSection.replace(":structureId", this.propertyData.structure);
    this.formActiveSubitemId = "";
    this.formActiveSection = section;

    this.updateFormSection();
  }

  /**
   * Handle form item click and open view/edit popup
   *
   * @since 1.0.0
   */
  onFormItemClick(rawSection: string, item: any): void {
    const top = document.getElementById("structure-card").offsetTop;
    window.scrollTo({
      top,
      behavior: "smooth"
    });

    const section = rawSection.replace(":structureId", this.propertyData.structure);
    this.formActiveSubitemId = item._id;
    this.formActiveSection = section;

    this.updateFormSection();
  }

  /**
   * Update form section depending on route params
   *
   * @since 1.0.0
   */
  updateFormSection(): void {
    // Reset model to prevent import previous form data
    if (this.model) {
      for (const property in this.model) {
        delete this.model[property];
      }
    }

    const top = document.getElementById("structure-card").offsetTop;
    window.scrollTo({
      top,
      behavior: "smooth"
    });

    // Reset data and call the new data form
    if (this.form) {
      this.options.formState = {
        disabled: true
      };
    }

    // Add section param to routing, which is used in connections type
    const params = Object.assign({}, this.activatedRoute.snapshot.params, { selected: false });
    params.mappingFormActiveSection = this.formActiveSection;
    this.activatedRoute.snapshot.params = params;

    if (this.formActiveSection) {
      this.formIsLoading = true; // Start form loading
      //mappingFormActiveSection = decodeURIComponent(mappingFormActiveSection);

      // BEGIN - Set open status to current mapping index
      const origFormActiveSection = this.formActiveSection.replace(
        this.propertyData.structure,
        ":structureId"
      );

      this.mappingIndex.map((item: MappingIndex) => {
        item.content.map((subItem: MappingIndex) => {
          if (subItem.section === origFormActiveSection) {
            // Get currente element is a Plant
            // delete note field from form
            if (subItem.formConfig
              && Array.isArray(subItem.formConfig)
              && subItem.formConfig.length) {
              if (subItem.formConfig[0].fieldGroup
                && Array.isArray(subItem.formConfig[0].fieldGroup)
                && subItem.formConfig[0].fieldGroup.length) {
                const index = subItem.formConfig[0].fieldGroup.findIndex((el: any) => {
                  return el.key === "note";
                })
                if (index > -1) {
                  subItem.formConfig[0].fieldGroup.splice(index, 1);
                }
              }
            }
            if (
              item.title === "properties.structures.impiantiElettrici" ||
              item.title === "properties.structures.trattamentoAcqua" ||
              item.title ===
              "properties.structures.riscaldamentoCondizionamento" ||
              item.title === "properties.structures.dispositiviAntincendio" ||
              item.title === "properties.structures.ascensoriEMontauto" ||
              item.title === "properties.structures.impiantiElettronici" ||
              item.title === "properties.structures.lineeVita" ||
              item.title === "properties.structures.impiantiSpeciali" ||
              item.title === "properties.structures.impiantiRicreativi"
            ) {
              this.sectionPlant = true;
            } else {
              this.sectionPlant = false;
            }

            item.expanded = true;
            subItem.active = true;
            this.activeItem = subItem;
            if (
              this.formActiveSection &&
              origFormActiveSection !==
              "condo-structures/:structureId/anagrafica"
            ) {
              const children = this.getChildren(subItem.key);
              if (children.length) {
                this.activeSubitem = children.find(
                  (val: any) => val._id === this.formActiveSubitemId
                );
                if (this.activeSubitem && this.activeSubitem.files) {
                  if (this.form.controls.files) {
                    this.form.controls.files.setValue(this.activeSubitem.files);
                  }
                  this.form.updateValueAndValidity();
                }
                this.fields = subItem.formConfig;

                if (this.activeSubitem) {
                  this.model = this.activeSubitem;
                } else {
                  // Add new subitem. Default name from section
                  const tot = children.length + 1;
                  const nome =
                    this.translateService.instant(subItem.title) + " " + tot;
                  this.model = { nome };
                }
              } else {
                // New first subitem. Default name from section
                this.fields = subItem.formConfig;
                const nome =
                  this.translateService.instant(subItem.title) + " 1";
                this.model = { nome };
              }
            } else if (
              subItem.section === "condo-structures/:structureId/anagrafica"
            ) {
              this.activeSubitem = this.condoStructure.anagrafica;
              // Anagrafica: is not completed
              if (typeof this.activeSubitem === "undefined") {
                this.activeSubitem = {
                  active: true
                };
              }
              this.fields = subItem.formConfig;
              this.model = this.activeSubitem;
              this.formActiveSubitemId = Math.random().toString();
            }
          } else {
            // item.expanded = false;
            subItem.active = false;
          }
        });
      });

      if (this.form && !this.condoStructure.open) {
        this.options.formState = {
          disabled: true
        };
      }
      // END - Set open status to current mapping index

      this.formIsLoading = false;

    } else {
      // Reset the last item.expanded mappingIndex to close tree from previous structure
      if (Array.isArray(this.mappingIndex) && this.mappingIndex.length) {
        this.mappingIndex.forEach((item: any) => {
          if (item.expanded) {
            item.expanded = false;
            if (Array.isArray(item.content) && item.content.length) {
              item.content.forEach((elem: any) => {
                if (elem.active) {
                  elem.active = false;
                }
              });
            }
          }
        });
      }
    }
  }

  /**
   * Get children (existing values) for requested section
   *
   * @since 1.0.0
   */
  getChildren(key: any): any[] {
    if (typeof this.condoStructure !== "undefined"
      && typeof this.condoStructure[key] !== "undefined") {
      if (key === "anagrafica") {
        return [];
      } else {
        if (Array.isArray(this.condoStructure[key])) {
          let structures = JSON.parse(
            JSON.stringify(this.condoStructure[key])
          );
          structures = structures.filter(el => el.active);
          return structures;
        } else {
          return [];
        }
      }
    }
    return [];
  }

  /**
   * Handle panel header open/close
   *
   * @since 1.0.0
   *
   */
  onPanelClicked(item: any, index: number): void {
    item.expanded = !item.expanded;
    this.mappingIndex.forEach((el: MappingIndex, i: number) => {
      if (i !== index) {
        el.expanded = false;
      }
    });

    // Handle scroll to panel
    if (item.expanded) {
      const offset = 400;
      const headerHeight = 60;
      const top = (headerHeight * (index + 1)) - headerHeight + offset;
      window.scrollTo({
        top,
        behavior: "smooth"
      });
    }
  }

  /**
   * Handle component destroy
   *
   * @since 1.0.0
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  originalOrder = (a: KeyValue<number, string>, b: KeyValue<number, string>): number => {
    return 0;
  }

  /**
    * Handle table sort
    *
    * @since 1.0.0
    */
  sortData(sort: Sort, i: string, t: string, x: string, pos: string): any {
    let sortedData = [];
    if (pos === '1') {
      sortedData = this.displayedDocs[i].content[t].content[x].content;
    } else if (pos === '2') {
      sortedData = this.displayedDocs[i].content[t].content;
    } else if (pos === '3') {
      sortedData = this.displayedDocs[i].content;
    }

    const data = sortedData;
    if (!sort.active || sort.direction === '') {
      sortedData = data;
      if (pos === '1') {
        this.displayedDocs[i].content[t].content[x].content = sortedData;
      } else if (pos === '2') {
        this.displayedDocs[i].content[t].content = sortedData;
      } else if (pos === '3') {
        this.displayedDocs[i].content = sortedData;
      }
      return;
    }

    sortedData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'title':
          return this.compare(a.title.toLowerCase(), b.title.toLowerCase(), isAsc);
        case 'data.contenutoDocumento':
          const aContenutoDocumento = (a.data && a.data.contenutoDocumento) ? a.data.contenutoDocumento.toLowerCase() : "";
          const bContenutoDocumento = (b.data && b.data.contenutoDocumento) ? b.data.contenutoDocumento.toLowerCase() : "";
          return this.compare(aContenutoDocumento, bContenutoDocumento, isAsc);
        case 'data.ragioneSocialeFornitore':
          const aRagioneSocialeFornitore = (a.data && a.data.ragioneSocialeFornitore) ? a.data.ragioneSocialeFornitore : "";
          const bRagioneSocialeFornitore = (b.data && b.data.ragioneSocialeFornitore) ? b.data.ragioneSocialeFornitore : "";
          return this.compare(aRagioneSocialeFornitore, bRagioneSocialeFornitore, isAsc);
        case 'data.dataDocumento':
          const aDataDocumento = (a.data && a.data.dataDocumento) ? a.data.dataDocumento : "";
          const bDataDocumento = (b.data && b.data.dataDocumento) ? b.data.dataDocumento : "";
          return this.compare(aDataDocumento, bDataDocumento, isAsc);
        case 'dateExpired':
          const aDateExpired = (a.dateExpired) ? a.dateExpired : "";
          const bDateExpired = (b.dateExpired) ? b.dateExpired : "";
          return this.compare(aDateExpired, bDateExpired, isAsc);
        default: return 0;
      }
    });

    if (pos === '1') {
      this.displayedDocs[i].content[t].content[x].content = sortedData;
    } else if (pos === '2') {
      this.displayedDocs[i].content[t].content = sortedData;
    } else if (pos === '3') {
      this.displayedDocs[i].content = sortedData;
    }
  }

  /**
   * Utility per table sort
   *
   * @since 1.0.0
   */
  compare(a: number | string | Date, b: number | string | Date, isAsc: boolean): any {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  /**
 * Handle side menu to expand panel
 *
 * @since 1.0.0
 */
  onItemOpen(item: DocumentInterface): void {
    item.expanded = true;
    this.documentsStructure.forEach((el: any) => {
      if (el.title !== item.title
        && el.expanded) {
        el.expanded = false;
      }
    });
  }

  /**
   * Handle side menu to close panel
   *
   * @since 1.0.0
   */
  onItemClose(item: DocumentInterface): void {
    item.expanded = false;
  }

  /**
 * Handle scroll to selected title
 *
 * @since 1.0.0
 */
  onTitleClicked(rawTitle: any) {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });

    setTimeout(() => {
      const title = this.translateService.instant(rawTitle);

      const docsWindow = document.getElementById("doc-wrapper");
      const target = document.getElementById(title);

      const top = target.offsetTop;

      docsWindow.scrollTo({
        top,
        behavior: "smooth"
      });
    }, 500);
  }

}
